(function () {
  var configEl = document.querySelector('[data-saved-lists-config]');
  if (!configEl) return;

  var config = {};
  try {
    config = JSON.parse(configEl.textContent || '{}');
  } catch (error) {
    console.warn('saved-lists: invalid config payload', error);
    return;
  }

  if (!config.enabled) return;

  var createdListStorageKey = 'saved_lists_has_created_list_' + String(config.customerId || 'guest');

  function getStoredCreatedListFlag() {
    try {
      return window.localStorage.getItem(createdListStorageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  function getLoyaltyEvaluateEnabled() {
    return Boolean(config.loyaltyEvaluateEnabled);
  }

  function setStoredCreatedListFlag(value) {
    try {
      if (value) {
        window.localStorage.setItem(createdListStorageKey, '1');
      } else {
        window.localStorage.removeItem(createdListStorageKey);
      }
    } catch (error) {
      // Ignore storage errors (private mode, storage disabled)
    }
  }

  var isCustomerLoggedIn = Boolean(config.isLoggedIn);
  var LIST_NAME_MAX_LENGTH = 80;
  var CARD_TITLE_MAX_LENGTH = 64;
  var MODAL_TITLE_MAX_LENGTH = 88;
  var ACTIVE_TITLE_MAX_LENGTH = 110;
  var PRODUCT_TITLE_MAX_LENGTH = 96;
  var BULK_DISCOUNT_DEFAULT_PCT = 5;
  var loyaltyEvaluateEnabled = getLoyaltyEvaluateEnabled();
  var NZ_DISPATCH_CUTOFF_HOUR = 12;
  var NZ_PUBLIC_HOLIDAYS = [
    '2026-01-01', '2026-01-02', '2026-02-06', '2026-04-03', '2026-04-06', '2026-04-27',
    '2026-06-01', '2026-06-19', '2026-10-26', '2026-12-25', '2026-12-28',
    '2027-01-01', '2027-01-04', '2027-02-08', '2027-03-26', '2027-03-29', '2027-04-26',
    '2027-06-07', '2027-07-09', '2027-10-25', '2027-12-27', '2027-12-28',
    '2028-01-03', '2028-01-04', '2028-02-07', '2028-04-14', '2028-04-17', '2028-04-25',
    '2028-06-05', '2028-06-23', '2028-10-23', '2028-12-25', '2028-12-26'
  ];

  var state = {
    lists: [],
    listsLoadedAt: 0,
    activeList: null,
    activeOrder: null,
    heartModal: null,
    orderListNameModal: null,
    heartContext: null,
    loading: false,
    page: null,
    orders: [],
    ordersPage: null,
    loyaltyEvaluateEnabled: loyaltyEvaluateEnabled,
    hasCreatedList: false,
    productPreviewCache: {},
    firstListEvaluationCache: {},
    activeListSavingsNonce: 0,
    cartLoyaltySummary: null,
    productQuantityOverride: null
  };
  var customerListCountPromise = null;
  var loyaltyContextListCount = 0;
  var loyaltyContextHasCreatedList = false;
  var productCalloutRenderNonce = 0;

  state.hasCreatedList = getStoredCreatedListFlag();
  loyaltyContextHasCreatedList = state.hasCreatedList;

  function getCurrentPath() {
    return window.location.pathname + window.location.search + window.location.hash;
  }

  function buildLoginUrl(returnUrl) {
    var loginUrl = config.loginUrl || '/account/login';
    var returnParam = config.loginReturnParam || 'return_url';

    try {
      var url = new URL(loginUrl, window.location.origin);
      url.searchParams.set(returnParam, returnUrl || getCurrentPath());
      return url.toString();
    } catch (error) {
      var fallback = loginUrl.indexOf('?') === -1 ? '?' : '&';
      return loginUrl + fallback + encodeURIComponent(returnParam) + '=' + encodeURIComponent(returnUrl || getCurrentPath());
    }
  }

  function redirectToLogin(returnUrl) {
    window.location.assign(buildLoginUrl(returnUrl));
  }

  function setSavedListsModalBodyState(isOpen) {
    if (!document.body) return;
    document.body.classList.toggle('saved-lists-modal-open', Boolean(isOpen));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeInlineText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function truncateTitle(value, maxLength) {
    var clean = normalizeInlineText(value);
    var limit = Math.max(8, toInteger(maxLength, 80));
    if (!clean || clean.length <= limit) return clean;

    var candidate = clean.slice(0, limit + 1);
    var lastSpace = candidate.lastIndexOf(' ');

    if (lastSpace > Math.floor(limit * 0.6)) {
      candidate = candidate.slice(0, lastSpace);
    } else {
      candidate = candidate.slice(0, limit);
    }

    return candidate.replace(/[.,;:!?-]+$/, '').trim() + '...';
  }

  function sanitizeListName(value) {
    var normalized = normalizeInlineText(value);
    if (normalized.length <= LIST_NAME_MAX_LENGTH) return normalized;
    return normalized.slice(0, LIST_NAME_MAX_LENGTH).trim();
  }

  function toInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function formatMoney(cents) {
    var numericCents = Number(cents || 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(numericCents, config.moneyFormat || '${{amount}}');
      } catch (error) {
        // Fall back to Intl formatting
      }
    }

    return new Intl.NumberFormat('en-NZ', {
      style: 'currency',
      currency: 'NZD'
    }).format(numericCents / 100);
  }

  function getDiscountedUnitPriceCents(basePriceCents, discountPct) {
    var price = Number(basePriceCents);
    var pct = Number(discountPct);

    if (!Number.isFinite(price) || price <= 0) return null;
    if (!Number.isFinite(pct) || pct <= 0) return Math.round(price);

    return Math.max(0, Math.round(price * (1 - (pct / 100))));
  }

  function formatDiscountedUnitPrice(basePriceCents, discountPct) {
    var discounted = getDiscountedUnitPriceCents(basePriceCents, discountPct);
    if (discounted === null) return '';
    return formatMoney(discounted);
  }

  function readMoneyValue(candidates, fallback) {
    var values = Array.isArray(candidates) ? candidates : [candidates];

    for (var index = 0; index < values.length; index += 1) {
      var raw = values[index];
      if (raw === '' || raw === null || typeof raw === 'undefined') continue;

      var parsed = Number(raw);
      if (Number.isFinite(parsed)) return parsed;
    }

    if (typeof fallback === 'number' && Number.isFinite(fallback)) {
      return fallback;
    }

    return null;
  }

  function readBooleanValue(candidates) {
    var values = Array.isArray(candidates) ? candidates : [candidates];

    for (var index = 0; index < values.length; index += 1) {
      var raw = values[index];
      if (raw === null || typeof raw === 'undefined' || raw === '') continue;

      if (typeof raw === 'boolean') return raw;
      if (typeof raw === 'number') return raw !== 0;

      var text = String(raw).trim().toLowerCase();
      if (text === 'true' || text === '1' || text === 'yes') return true;
      if (text === 'false' || text === '0' || text === 'no') return false;
    }

    return null;
  }

  function padTwoDigits(value) {
    var number = toInteger(value, 0);
    if (number < 10) return '0' + String(number);
    return String(number);
  }

  function getNzNowParts() {
    var formatter = new Intl.DateTimeFormat('en-NZ', {
      timeZone: 'Pacific/Auckland',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });

    var parsed = {};
    formatter.formatToParts(new Date()).forEach(function (part) {
      parsed[part.type] = part.value;
    });

    var year = toInteger(parsed.year, 0);
    var month = toInteger(parsed.month, 0);
    var day = toInteger(parsed.day, 0);
    var hour = toInteger(parsed.hour, 0);
    var minute = toInteger(parsed.minute, 0);

    if (year <= 0 || month <= 0 || day <= 0) return null;

    return {
      year: year,
      month: month,
      day: day,
      hour: hour,
      minute: minute
    };
  }

  function buildUtcCivilDate(parts) {
    return new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
  }

  function addUtcDays(date, dayCount) {
    return new Date(date.getTime() + toInteger(dayCount, 0) * 86400000);
  }

  function formatUtcDateYmd(date) {
    return [
      String(date.getUTCFullYear()),
      padTwoDigits(date.getUTCMonth() + 1),
      padTwoDigits(date.getUTCDate())
    ].join('-');
  }

  function isNzPublicHoliday(date) {
    return NZ_PUBLIC_HOLIDAYS.indexOf(formatUtcDateYmd(date)) !== -1;
  }

  function isNzBusinessDay(date) {
    var dayOfWeek = date.getUTCDay();
    var isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
    if (isWeekend) return false;
    return !isNzPublicHoliday(date);
  }

  function findNextNzBusinessDay(startDate, dayOffset) {
    var candidate = addUtcDays(startDate, dayOffset);
    var guard = 0;

    while (guard < 30 && !isNzBusinessDay(candidate)) {
      candidate = addUtcDays(candidate, 1);
      guard += 1;
    }

    return candidate;
  }

  function formatNzBusinessDate(date) {
    var weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return weekdays[date.getUTCDay()] + ' ' + String(date.getUTCDate()) + ' ' + months[date.getUTCMonth()];
  }

  function getNzEtaTargetLabel(today, etaDate) {
    if (!today || !etaDate) return '';
    var diffDays = Math.round((etaDate.getTime() - today.getTime()) / 86400000);
    if (diffDays === 1) return 'tomorrow';
    return formatNzBusinessDate(etaDate);
  }

  function getNzDispatchContext() {
    var nowParts = getNzNowParts();
    if (!nowParts) return null;

    var today = buildUtcCivilDate(nowParts);
    var isBeforeCutoff = nowParts.hour < NZ_DISPATCH_CUTOFF_HOUR;
    var isTodayWorkingDay = isNzBusinessDay(today);
    var dispatchDate = (isTodayWorkingDay && isBeforeCutoff)
      ? today
      : findNextNzBusinessDay(today, 1);
    var etaDate = findNextNzBusinessDay(dispatchDate, 1);
    var etaTargetLabel = getNzEtaTargetLabel(today, etaDate);
    var dispatchLine = '';
    var etaLine = '';

    if (isTodayWorkingDay && isBeforeCutoff) {
      dispatchLine = 'Dispatches today.';
      etaLine = 'Order before 12pm NZT for delivery by ' + etaTargetLabel + '.';
    } else if (isTodayWorkingDay) {
      dispatchLine = 'Ready for immediate dispatch.';
      etaLine = 'Estimated delivery by ' + etaTargetLabel + '.';
    } else {
      dispatchLine = 'Ready for immediate dispatch on next working day.';
      etaLine = 'Estimated delivery by ' + etaTargetLabel + '.';
    }

    etaLine += ' Rural: +1-2 working days.';

    return {
      dispatchLine: dispatchLine,
      etaLine: etaLine
    };
  }

  function getSupplierShippingContext(availabilityStatus) {
    var status = normalizeInlineText(availabilityStatus || '').toLowerCase();
    if (!status) return null;

    var isAustralianSupplier = status.indexOf('australian') !== -1
      || status.indexOf('australia') !== -1
      || status.indexOf('au_supplier') !== -1
      || status.indexOf('supplier_au') !== -1;

    if (isAustralianSupplier) {
      return {
        stockLabel: 'Available',
        timeframeText: 'Estimated delivery 7-12 working days.',
        detailText: 'Ships from Australian Supplier. Rural: +1-2 working days.'
      };
    }

    var isNzSupplier = status.indexOf('nz_supplier') !== -1
      || status.indexOf('new_zealand') !== -1
      || status.indexOf('new zealand') !== -1
      || status.indexOf('from_nz') !== -1;

    if (isNzSupplier) {
      return {
        stockLabel: 'Available',
        timeframeText: 'Estimated delivery 2-5 working days.',
        detailText: 'Ships from NZ Supplier. Rural: +1-2 working days.'
      };
    }

    var isSupplier = status.indexOf('supplier') !== -1
      || status.indexOf('dropship') !== -1
      || status.indexOf('drop_ship') !== -1
      || status.indexOf('drop ship') !== -1;

    if (!isSupplier) return null;

    return {
      stockLabel: 'Available',
      timeframeText: 'Estimated delivery 3-10 working days.',
      detailText: 'Ships from Supplier. Rural: +1-2 working days.'
    };
  }

  function getCompactEtaText(etaLine) {
    var text = normalizeInlineText(etaLine || '');
    if (!text) return '';
    return text.replace(/\s*Rural:\s*\+?\d+\s*-\s*\d+\s*working\s*days\.?/i, '').trim();
  }

  function markAvailabilityMessagingReady() {
    var productMain = document.querySelector('.product-main[data-availability-pending]');
    if (!productMain) return;
    productMain.removeAttribute('data-availability-pending');
    productMain.setAttribute('data-availability-ready', 'true');
  }

  function parseVariantAvailabilityMap(rawValue) {
    var map = {};
    var text = normalizeInlineText(rawValue || '');
    if (!text) return map;

    text.split('|').forEach(function (entry) {
      var pair = String(entry || '');
      if (!pair) return;

      var dividerIndex = pair.indexOf(':');
      if (dividerIndex <= 0) return;

      var variantId = normalizeInlineText(pair.slice(0, dividerIndex));
      if (!variantId) return;

      map[variantId] = normalizeInlineText(pair.slice(dividerIndex + 1));
    });

    return map;
  }

  function getVariantAvailabilityMap(callout) {
    if (!callout) return {};

    var rawMap = callout.getAttribute('data-product-availability-map') || '';
    if (callout._productAvailabilityMapRaw !== rawMap) {
      callout._productAvailabilityMapRaw = rawMap;
      callout._productAvailabilityMap = parseVariantAvailabilityMap(rawMap);
    }

    return callout._productAvailabilityMap || {};
  }

  function getVariantAvailabilityStatus(callout, variantId) {
    if (!callout || !variantId) return '';
    var availabilityMap = getVariantAvailabilityMap(callout);
    return normalizeInlineText(availabilityMap[String(variantId)] || '');
  }

  function parseJsonAttribute(rawValue, fallback) {
    var text = normalizeInlineText(rawValue || '');
    if (!text) return fallback;

    try {
      return JSON.parse(text);
    } catch (error) {
      return fallback;
    }
  }

  function getVariantBulkPriceMap(callout) {
    if (!callout) return {};

    var rawMap = callout.getAttribute('data-product-loyalty-bulk-price-map') || '{}';
    if (callout._productBulkPriceMapRaw !== rawMap) {
      callout._productBulkPriceMapRaw = rawMap;
      callout._productBulkPriceMap = parseJsonAttribute(rawMap, {});
    }

    return callout._productBulkPriceMap || {};
  }

  function getVariantBulkPriceCents(callout, variantId) {
    if (!callout || !variantId) return null;
    var bulkPriceMap = getVariantBulkPriceMap(callout);
    return readMoneyValue(bulkPriceMap[String(variantId)], null);
  }

  function getBulkPriceMessageHtml(bulkPriceText, hasQtyTier) {
    if (!bulkPriceText) return '';

    if (hasQtyTier) {
      return '<strong>' + escapeHtml(bulkPriceText) + '</strong> bulk price will be applied in cart.';
    }

    return '<strong>' + escapeHtml(bulkPriceText) + '</strong> when you order 2 or more.';
  }

  function setProductCalloutLoading(callout) {
    if (!callout || !isCustomerLoggedIn || !state.loyaltyEvaluateEnabled) return;

    var inlineContainer = callout.closest('[data-product-loyalty-inline]');
    var variantId = callout.getAttribute('data-product-loyalty-variant-id') || '';
    var basePriceCents = readMoneyValue(callout.getAttribute('data-product-loyalty-price'), null);
    var bulkPriceCents = getVariantBulkPriceCents(callout, variantId);
    var isOnSaleItem = readBooleanValue(callout.getAttribute('data-product-loyalty-on-sale')) === true;
    var hasBulkPrice = (
      Number.isFinite(basePriceCents) &&
      Number.isFinite(bulkPriceCents) &&
      bulkPriceCents > 0 &&
      bulkPriceCents < basePriceCents
    );

    if (isOnSaleItem || !hasBulkPrice) return;

    if (inlineContainer) {
      setElementVisible(inlineContainer, true);
    }
    callout.setAttribute('data-product-loyalty-state', 'loading');
    callout.setAttribute('aria-busy', 'true');
  }

  function formatPercentValue(value) {
    var numeric = Number(value);
    if (!Number.isFinite(numeric) || numeric <= 0) return '';

    var rounded = Math.round(numeric * 10) / 10;
    if (Math.abs(rounded - Math.round(rounded)) < 0.0001) {
      return String(Math.round(rounded));
    }

    return rounded.toFixed(1);
  }

  function getIneligibleReasonText(reason) {
    var normalized = normalizeInlineText(reason || '').toLowerCase();

    if (!normalized) return 'Not eligible for loyalty savings.';
    if (normalized === 'already_discounted') return 'Already discounted.';
    if (normalized === 'on_sale' || normalized === 'sale_item') return 'Sale item.';
    if (normalized === 'on_compare_at_sale') return 'Sale item excluded.';
    if (normalized === 'not_full_price') return 'Sale item excluded.';
    if (normalized === 'source_not_allowed') return 'Not eligible from this source.';
    if (normalized === 'margin_floor') return 'Below margin threshold.';
    if (normalized === 'missing_source') return 'Not added via saved lists or re-order.';

    return 'Not eligible for loyalty savings.';
  }

  function findEvaluateLineResult(payload, lineIndex) {
    var lines = payload && Array.isArray(payload.lines) ? payload.lines : [];
    if (!lines.length) return null;

    var normalizedIndex = toInteger(lineIndex, 0);
    var indexedMatch = lines.find(function (line) {
      return toInteger(line && line.index, -1) === normalizedIndex;
    });
    if (indexedMatch) return indexedMatch;

    if (normalizedIndex >= 0 && normalizedIndex < lines.length) {
      return lines[normalizedIndex];
    }

    return lines[0] || null;
  }

  function normalizeFirstListRewardEvaluation(payload, lineIndex, options) {
    var line = findEvaluateLineResult(payload, lineIndex);
    var lineEligibility = line && line.eligibility ? line.eligibility.first_list : null;
    var lineReward = line && (line.first_list_reward || line.firstListReward);
    var reward = payload && (payload.first_list_reward || payload.firstListReward || payload.first_list);
    var opts = options || {};
    var isUnlocked = readBooleanValue([
      reward && reward.is_unlocked,
      reward && reward.isUnlocked,
      payload && payload.first_list && payload.first_list.is_unlocked,
      payload && payload.first_list && payload.first_list.isUnlocked
    ]) === true;
    var isRedeemed = readBooleanValue([
      reward && reward.is_redeemed,
      reward && reward.isRedeemed,
      payload && payload.first_list && payload.first_list.is_redeemed,
      payload && payload.first_list && payload.first_list.isRedeemed
    ]) === true;
    var eligible = readBooleanValue([
      lineEligibility && lineEligibility.eligible,
      line && line.first_list_eligible,
      line && line.firstListEligible,
      lineReward && lineReward.eligible
    ]) === true;
    var reason = normalizeInlineText([
      lineEligibility && lineEligibility.reason,
      line && line.first_list_reason,
      line && line.firstListReason,
      lineReward && lineReward.reason
    ].find(function (entry) {
      return entry !== null && typeof entry !== 'undefined' && String(entry).trim() !== '';
    }) || '');
    var discountPct = readMoneyValue([
      lineReward && lineReward.applied_discount_pct,
      lineReward && lineReward.appliedDiscountPct,
      lineReward && lineReward.discount_pct,
      lineReward && lineReward.discountPct,
      reward && reward.applied_discount_pct,
      reward && reward.appliedDiscountPct,
      reward && reward.discount_pct,
      reward && reward.discountPct
    ], 0);
    var applies = readBooleanValue([
      lineReward && lineReward.applies,
      lineReward && lineReward.applied,
      lineReward && lineReward.is_applied,
      reward && reward.applies_to_line,
      reward && reward.applies
    ]);

    if (applies === null) {
      applies = Boolean(eligible && isUnlocked && !isRedeemed && Number(discountPct) > 0);
    }

    var discountedUnitPriceCents = readMoneyValue([
      lineReward && lineReward.discounted_unit_price_cents,
      lineReward && lineReward.discountedUnitPriceCents,
      lineReward && lineReward.discounted_price_cents,
      lineReward && lineReward.discountedPriceCents
    ], null);

    var basePriceCents = readMoneyValue(opts.basePriceCents, null);
    if (discountedUnitPriceCents === null && basePriceCents !== null && Number(discountPct) > 0) {
      discountedUnitPriceCents = getDiscountedUnitPriceCents(basePriceCents, discountPct);
    }

    return {
      eligible: eligible,
      applies: applies === true,
      discountPct: Number.isFinite(Number(discountPct)) ? Number(discountPct) : 0,
      discountedUnitPriceCents: discountedUnitPriceCents,
      reason: reason,
      isUnlocked: isUnlocked,
      isRedeemed: isRedeemed
    };
  }

  async function evaluateFirstListRewardForLine(options) {
    var opts = options || {};
    var variantId = String(opts.variantId || '').trim();
    if (!variantId) return null;
    if (!state.loyaltyEvaluateEnabled || !isCustomerLoggedIn) return null;

    var quantity = Math.max(1, toInteger(opts.quantity, 1));
    var basePriceCents = readMoneyValue(opts.basePriceCents, null);
    var compareAtPriceCents = readMoneyValue(opts.compareAtPriceCents, null);
    var cacheKey = [
      variantId,
      String(quantity),
      String(basePriceCents),
      String(compareAtPriceCents)
    ].join('|');

    if (Object.prototype.hasOwnProperty.call(state.firstListEvaluationCache, cacheKey)) {
      return state.firstListEvaluationCache[cacheKey];
    }

    var requestLine = {
      index: 0,
      variant_id: variantId,
      quantity: quantity,
      properties: {}
    };

    if (basePriceCents !== null) {
      requestLine.price = Math.max(0, Math.round(basePriceCents));
    }
    if (compareAtPriceCents !== null) {
      requestLine.compare_at_price = Math.max(0, Math.round(compareAtPriceCents));
    }

    var requestBody = {
      lines: [requestLine]
    };

    try {
      var payload = await api('/loyalty/lines/evaluate', {
        method: 'POST',
        body: requestBody
      });
      var normalized = normalizeFirstListRewardEvaluation(payload, 0, {
        basePriceCents: basePriceCents
      });
      state.firstListEvaluationCache[cacheKey] = normalized;
      return normalized;
    } catch (error) {
      state.firstListEvaluationCache[cacheKey] = null;
      return null;
    }
  }

  function normalizeLoyaltyEvaluateLine(line) {
    var entry = line || {};
    var lineSavingsAmountCents = readMoneyValue([
      entry.line_savings_amount_cents,
      entry.line_savings_amount,
      entry.lineSavingsAmountCents,
      entry.lineSavingsAmount
    ], 0);
    if (!Number.isFinite(lineSavingsAmountCents) || lineSavingsAmountCents < 0) {
      lineSavingsAmountCents = 0;
    } else {
      lineSavingsAmountCents = Math.max(0, Math.round(lineSavingsAmountCents));
    }

    var lineSavingsType = normalizeInlineText([
      entry.line_savings_type,
      entry.lineSavingsType
    ].find(function (value) {
      return value !== null && typeof value !== 'undefined' && String(value).trim() !== '';
    }) || '').toLowerCase();

    var firstListReward = entry.first_list_reward || entry.firstListReward || {};
    var reorderReward = entry.reorder_reward || entry.reorderReward || {};
    var firstListEligibility = entry.eligibility && entry.eligibility.first_list
      ? entry.eligibility.first_list
      : {};
    var reorderEligibility = entry.eligibility && entry.eligibility.reorder
      ? entry.eligibility.reorder
      : {};
    var firstListApplies = readBooleanValue([
      firstListReward.applies,
      firstListReward.applied,
      firstListReward.is_applied
    ]) === true;
    var reorderApplies = readBooleanValue([
      reorderReward.applies,
      reorderReward.applied,
      reorderReward.is_applied
    ]) === true;
    var appliedDiscountPct = readMoneyValue([
      entry.applied_discount_pct,
      entry.appliedDiscountPct,
      reorderReward.applied_discount_pct,
      reorderReward.appliedDiscountPct,
      firstListReward.applied_discount_pct,
      firstListReward.appliedDiscountPct
    ], 0);
    if (!Number.isFinite(appliedDiscountPct) || appliedDiscountPct < 0) {
      appliedDiscountPct = 0;
    } else {
      appliedDiscountPct = Number(appliedDiscountPct);
    }

    var ineligibleReason = '';
    if (!firstListApplies && !reorderApplies && lineSavingsAmountCents <= 0) {
      if (readBooleanValue(firstListEligibility.eligible) === false) {
        ineligibleReason = normalizeInlineText(firstListEligibility.reason || '');
      }
      if (!ineligibleReason && readBooleanValue(reorderEligibility.eligible) === false) {
        ineligibleReason = normalizeInlineText(reorderEligibility.reason || '');
      }
    }

    return {
      index: toInteger(entry.index, -1),
      lineSavingsAmountCents: lineSavingsAmountCents,
      lineSavingsType: lineSavingsType,
      appliedDiscountPct: appliedDiscountPct,
      firstListApplies: firstListApplies,
      reorderApplies: reorderApplies,
      ineligibleReason: ineligibleReason
    };
  }

  function normalizeLoyaltyEvaluateSummary(payload) {
    var lines = payload && Array.isArray(payload.lines) ? payload.lines : [];
    var normalizedLines = lines.map(normalizeLoyaltyEvaluateLine);
    var lineSavingsTotal = 0;
    var lineFirstListSavings = 0;
    var lineReorderSavings = 0;

    normalizedLines.forEach(function (line) {
      var amount = Number(line && line.lineSavingsAmountCents || 0);
      if (!Number.isFinite(amount) || amount <= 0) return;

      lineSavingsTotal += amount;
      if (line.lineSavingsType === 'first_list_10') {
        lineFirstListSavings += amount;
      } else if (line.lineSavingsType === 'reorder_tier') {
        lineReorderSavings += amount;
      }
    });

    var totalSavingsCents = readMoneyValue([
      payload && payload.order_total_savings_cents,
      payload && payload.order_total_savings,
      payload && payload.orderTotalSavingsCents,
      payload && payload.orderTotalSavings
    ], null);
    var firstListSavingsCents = readMoneyValue([
      payload && payload.order_first_list_savings_cents,
      payload && payload.order_first_list_savings,
      payload && payload.orderFirstListSavingsCents,
      payload && payload.orderFirstListSavings
    ], null);
    var reorderSavingsCents = readMoneyValue([
      payload && payload.order_reorder_savings_cents,
      payload && payload.order_reorder_savings,
      payload && payload.orderReorderSavingsCents,
      payload && payload.orderReorderSavings
    ], null);

    if (!Number.isFinite(firstListSavingsCents) || firstListSavingsCents < 0) {
      firstListSavingsCents = lineFirstListSavings;
    } else {
      firstListSavingsCents = Math.max(0, Math.round(firstListSavingsCents));
    }

    if (!Number.isFinite(reorderSavingsCents) || reorderSavingsCents < 0) {
      reorderSavingsCents = lineReorderSavings;
    } else {
      reorderSavingsCents = Math.max(0, Math.round(reorderSavingsCents));
    }

    if (!Number.isFinite(totalSavingsCents) || totalSavingsCents < 0) {
      totalSavingsCents = firstListSavingsCents + reorderSavingsCents;
      if (totalSavingsCents <= 0) {
        totalSavingsCents = lineSavingsTotal;
      }
    } else {
      totalSavingsCents = Math.max(0, Math.round(totalSavingsCents));
    }

    return {
      totalSavingsCents: totalSavingsCents,
      firstListSavingsCents: firstListSavingsCents,
      reorderSavingsCents: reorderSavingsCents,
      lines: normalizedLines
    };
  }

  async function evaluateLoyaltyForCartItems(items) {
    if (!state.loyaltyEvaluateEnabled || !isCustomerLoggedIn) return null;

    var lines = (Array.isArray(items) ? items : [])
      .map(function (item, index) {
        var variantId = String(item && (item.id || item.variant_id || item.variantId) || '').trim();
        var quantity = Math.max(1, toInteger(item && item.quantity, 1));
        if (!variantId) return null;

        var line = {
          index: index,
          variant_id: variantId,
          quantity: quantity
        };
        var priceCents = readMoneyValue([
          item && item.price,
          item && item.price_cents,
          item && item.priceCents
        ], null);
        var compareAtPriceCents = readMoneyValue([
          item && item.compare_at_price,
          item && item.compareAtPrice,
          item && item.compareAtPriceCents
        ], null);

        if (priceCents !== null) {
          line.price = Math.max(0, Math.round(priceCents));
        }
        if (compareAtPriceCents !== null) {
          line.compare_at_price = Math.max(0, Math.round(compareAtPriceCents));
        }

        if (item && item.properties && typeof item.properties === 'object') {
          var properties = {};
          Object.keys(item.properties).forEach(function (key) {
            properties[key] = String(item.properties[key]);
          });
          if (Object.keys(properties).length) {
            line.properties = properties;
          }
        }

        return line;
      })
      .filter(Boolean);

    if (!lines.length) return null;

    try {
      var payload = await api('/loyalty/lines/evaluate', {
        method: 'POST',
        body: { lines: lines }
      });
      return normalizeLoyaltyEvaluateSummary(payload);
    } catch (error) {
      return null;
    }
  }

  async function parseResponse(response) {
    var contentType = response.headers.get('content-type') || '';

    if (contentType.indexOf('application/json') !== -1) {
      return response.json();
    }

    var text = await response.text();

    try {
      return JSON.parse(text);
    } catch (error) {
      return { message: text };
    }
  }

  function nextFrame() {
    return new Promise(function (resolve) {
      window.requestAnimationFrame(function () {
        resolve();
      });
    });
  }

  function isIconOnlyButton(button) {
    if (!button) return false;
    if (button.classList.contains('saved-lists-line-actions__remove')) return true;

    var text = normalizeInlineText((button.textContent || '').replace(/\u00a0/g, ' '));
    return text.length === 0;
  }

  function beginButtonLoading(button, label) {
    if (!button) {
      return function () {};
    }

    var hadExplicitDisabled = button.hasAttribute('disabled');
    var previousDisabled = button.disabled;
    var previousHtml = button.innerHTML;
    var iconOnly = isIconOnlyButton(button);
    var hadAriaLabel = button.hasAttribute('aria-label');
    var previousAriaLabel = button.getAttribute('aria-label');
    var hadTitle = button.hasAttribute('title');
    var previousTitle = button.getAttribute('title');

    if (label) {
      if (iconOnly) {
        button.classList.add('is-loading-icon-only');
        button.setAttribute('aria-label', label);
        button.setAttribute('title', label);
      } else {
        button.textContent = label;
      }
    }

    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    return function (options) {
      var opts = options || {};
      var keepDisabled = Boolean(opts.keepDisabled);

      button.classList.remove('is-loading');
      button.classList.remove('is-loading-icon-only');
      button.removeAttribute('aria-busy');
      button.innerHTML = previousHtml;

      if (iconOnly) {
        if (hadAriaLabel) {
          button.setAttribute('aria-label', previousAriaLabel || '');
        } else {
          button.removeAttribute('aria-label');
        }

        if (hadTitle) {
          button.setAttribute('title', previousTitle || '');
        } else {
          button.removeAttribute('title');
        }
      }

      if (keepDisabled) {
        button.disabled = true;
      } else if (hadExplicitDisabled) {
        button.disabled = previousDisabled;
      } else {
        button.disabled = false;
      }
    };
  }

  function setRegionBusy(element, isBusy) {
    if (!element) return;
    element.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  function setTableLoadingRow(tbody, colSpan, rowClassName, message) {
    if (!tbody) return;
    tbody.innerHTML = [
      '<tr class="' + escapeHtml(rowClassName) + '">',
      '  <td colspan="' + escapeHtml(String(colSpan || 1)) + '">' + escapeHtml(message || 'Loading...') + '</td>',
      '</tr>'
    ].join('');
  }

  async function api(path, options) {
    var settings = options || {};
    var method = settings.method || 'GET';
    var hasBody = settings.body && method !== 'GET';

    var requestInit = {
      method: method,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      }
    };

    if (hasBody) {
      requestInit.body = JSON.stringify(settings.body);
    }

    var response = null;
    try {
      response = await fetch((config.apiBase || '/apps/saved-lists') + path, requestInit);
    } catch (error) {
      throw error;
    }

    var payload = await parseResponse(response);

    if (!response.ok) {
      var message = payload && (payload.error || payload.message || payload.description);
      throw new Error(message || 'Unable to process saved lists request.');
    }

    return payload;
  }

  function normalizeItem(rawItem) {
    var item = rawItem || {};
    var variantId = item.variant_id || item.variantId || item.v || item.id;
    var estimatedSavingsCents = readMoneyValue([
      item.estimatedSavingsCents,
      item.estimated_savings_cents,
      item.estimated_savings_amount_cents
    ], 0);
    var estimatedFirstListSavingsCents = readMoneyValue([
      item.estimatedFirstListSavingsCents,
      item.estimated_first_list_savings_cents
    ], 0);
    var estimatedReorderSavingsCents = readMoneyValue([
      item.estimatedReorderSavingsCents,
      item.estimated_reorder_savings_cents
    ], 0);
    var estimatedReorderDiscountPct = readMoneyValue([
      item.estimatedReorderDiscountPct,
      item.estimated_reorder_discount_pct
    ], 0);
    var fullPriceEligible = readBooleanValue([
      item.fullPriceEligible,
      item.full_price_eligible
    ]);

    if (!Number.isFinite(estimatedSavingsCents) || estimatedSavingsCents < 0) estimatedSavingsCents = 0;
    if (!Number.isFinite(estimatedFirstListSavingsCents) || estimatedFirstListSavingsCents < 0) estimatedFirstListSavingsCents = 0;
    if (!Number.isFinite(estimatedReorderSavingsCents) || estimatedReorderSavingsCents < 0) estimatedReorderSavingsCents = 0;
    if (!Number.isFinite(estimatedReorderDiscountPct) || estimatedReorderDiscountPct < 0) estimatedReorderDiscountPct = 0;
    var compareAtPrice = readMoneyValue([
      item.compareAtPrice,
      item.compare_at_price,
      item.compare_at_price_cents
    ], null);

    return {
      variantId: String(variantId || ''),
      quantity: toInteger(item.quantity || item.q, 1),
      productTitle: normalizeInlineText(item.product_title || item.productTitle || item.title || 'Untitled product') || 'Untitled product',
      productUrl: item.product_url || item.productUrl || item.url || '',
      imageUrl: item.image_url || item.imageUrl || item.image || '',
      variantTitle: item.variant_title || item.variantTitle || '',
      price: Number(item.price || item.price_cents || 0),
      compareAtPrice: compareAtPrice,
      available: item.available !== false,
      estimatedSavingsCents: estimatedSavingsCents,
      estimatedFirstListSavingsCents: estimatedFirstListSavingsCents,
      estimatedReorderSavingsCents: estimatedReorderSavingsCents,
      estimatedReorderDiscountPct: estimatedReorderDiscountPct,
      fullPriceEligible: fullPriceEligible,
      ineligibleReason: item.ineligibleReason || item.ineligible_reason || '',
      liveSavingsCents: null,
      liveSavingsType: '',
      liveAppliedDiscountPct: 0,
      liveIneligibleReason: ''
    };
  }

  function normalizeList(rawList) {
    var list = rawList || {};
    var items = Array.isArray(list.items) ? list.items.map(normalizeItem) : [];

    return {
      id: String(list.id || list._id || list.list_id || ''),
      name: sanitizeListName(list.name || 'Untitled list') || 'Untitled list',
      itemCount: toInteger(list.item_count || list.items_count, items.length),
      items: items
    };
  }

  function getListsFromPayload(payload) {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload.lists)) return payload.lists;
    if (payload.data && Array.isArray(payload.data.lists)) return payload.data.lists;
    return [];
  }

  function getListFromPayload(payload) {
    if (payload && payload.list) return payload.list;
    if (payload && payload.data && payload.data.list) return payload.data.list;
    return payload;
  }

  function readCreatedListFlagFromPayload(payload) {
    var source = payload || {};
    var loyalty = source && typeof source === 'object' ? source.loyalty : null;

    return readBooleanValue([
      source.has_created_list,
      source.hasCreatedList,
      source.has_created_list_before,
      source.hasCreatedListBefore,
      source.customer_has_created_list,
      source.customerHasCreatedList,
      source.customer_has_created_list_before,
      source.customerHasCreatedListBefore,
      loyalty && loyalty.has_created_list,
      loyalty && loyalty.hasCreatedList
    ]);
  }

  function markCustomerHasCreatedList() {
    if (state.hasCreatedList) return;
    state.hasCreatedList = true;
    loyaltyContextHasCreatedList = true;
    setStoredCreatedListFlag(true);
  }

  function hasCreatedListForContext(listCount) {
    return Boolean(state.hasCreatedList || Number(listCount || 0) > 0);
  }

  async function fetchLists(force) {
    var shouldForce = Boolean(force);

    if (!shouldForce && state.lists.length && Date.now() - state.listsLoadedAt < 30000) {
      return state.lists;
    }

    var payload = await api('/lists');
    state.lists = getListsFromPayload(payload).map(normalizeList).filter(function (list) {
      return list.id;
    });
    state.productPreviewCache = {};

    var hasCreatedFromPayload = readCreatedListFlagFromPayload(payload);
    if (hasCreatedFromPayload === true || state.lists.length > 0) {
      markCustomerHasCreatedList();
    }

    state.listsLoadedAt = Date.now();
    customerListCountPromise = Promise.resolve(state.lists.length);
    return state.lists;
  }

  function setElementVisible(el, isVisible) {
    if (!el) return;
    el.hidden = !Boolean(isVisible);
  }

  function setElementText(el, value) {
    if (!el) return;
    el.textContent = value || '';
  }

  function setElementHtml(el, value) {
    if (!el) return;
    el.innerHTML = value || '';
  }

  function getCustomerListCount(force) {
    if (!isCustomerLoggedIn) return Promise.resolve(0);

    var shouldForce = Boolean(force);
    if (shouldForce) {
      customerListCountPromise = null;
    }

    if (customerListCountPromise) {
      return customerListCountPromise;
    }

    customerListCountPromise = fetchLists(shouldForce)
      .then(function (lists) {
        return Array.isArray(lists) ? lists.length : 0;
      })
      .catch(function () {
        return 0;
      });

    return customerListCountPromise;
  }

  function updateSavedListsCallout(listCount, hasCreatedList) {
    var callout = document.querySelector('[data-saved-lists-loyalty-callout]');
    if (!callout) return;

    var firstListLine = callout.querySelector('[data-saved-lists-callout-line-first-list]');
    var reorderLine = callout.querySelector('[data-saved-lists-callout-line-reorder]');
    var qty2Line = callout.querySelector('[data-saved-lists-callout-line-qty2]');
    var dynamic = callout.querySelector('[data-saved-lists-callout-dynamic]');
    var hasLists = listCount > 0;
    var hasCreated = Boolean(hasCreatedList);

    if (!isCustomerLoggedIn) {
      setElementVisible(firstListLine, true);
      setElementVisible(reorderLine, false);
      setElementVisible(qty2Line, false);
      setElementHtml(dynamic, '<a href="' + escapeHtml(config.loginToSavedListsUrl || buildLoginUrl(config.savedListsUrl || '/pages/saved-lists')) + '">Sign in</a> to create your first list and unlock 10% savings.');
      return;
    }

    setElementVisible(firstListLine, !hasCreated);
    setElementVisible(reorderLine, hasLists);
    setElementVisible(qty2Line, true);

    if (hasLists) {
      setElementText(dynamic, 'Add list items to cart to see savings on eligible lines.');
    } else if (hasCreated) {
      setElementText(dynamic, 'Create a saved list to start tracking re-order and bulk savings.');
    } else {
      setElementText(dynamic, 'Create your first list to unlock your one-time 10% reward.');
    }
  }

  function updateOrdersCallout(listCount, hasCreatedList) {
    var callout = document.querySelector('[data-orders-loyalty-callout]');
    if (!callout) return;

    var firstListLine = callout.querySelector('[data-orders-callout-line-first-list]');
    var reorderLine = callout.querySelector('[data-orders-callout-line-reorder]');
    var qty2Line = callout.querySelector('[data-orders-callout-line-qty2]');
    var dynamic = callout.querySelector('[data-orders-callout-dynamic]');
    var hasLists = listCount > 0;
    var hasCreated = Boolean(hasCreatedList);

    if (!isCustomerLoggedIn) {
      setElementVisible(firstListLine, true);
      setElementVisible(reorderLine, false);
      setElementVisible(qty2Line, false);
      setElementHtml(dynamic, '<a href="' + escapeHtml(buildLoginUrl(getCurrentPath())) + '">Sign in</a> to access re-order savings.');
      return;
    }

    setElementVisible(firstListLine, !hasCreated);
    setElementVisible(reorderLine, true);
    setElementVisible(qty2Line, true);

    if (hasLists) {
      setElementText(dynamic, 'Use Order again to apply savings on eligible lines.');
    } else if (hasCreated) {
      setElementText(dynamic, 'Use Order again and increase quantity to unlock bulk savings where available.');
    } else {
      setElementText(dynamic, 'Create your first saved list to unlock your one-time 10% reward.');
    }
  }

  function isVisibleInput(input) {
    if (!input || input.type === 'hidden' || input.disabled) return false;
    if (input.closest('[hidden]')) return false;

    if (input.offsetParent !== null) return true;
    return input.getClientRects().length > 0;
  }

  function getProductQuantity(callout) {
    if (Number.isFinite(state.productQuantityOverride) && state.productQuantityOverride > 0) {
      return Math.round(state.productQuantityOverride);
    }

    var scope = callout ? (callout.closest('.product--outer') || document) : document;
    var quantityInputs = Array.prototype.slice.call(scope.querySelectorAll('input[name="quantity"]'));
    if (!quantityInputs.length) return 1;

    var quantityInput = quantityInputs.find(isVisibleInput) || quantityInputs[0];
    var quantity = toInteger(quantityInput && quantityInput.value, 1);

    return quantity >= 0 ? quantity : 1;
  }

  function isPriceOnSale(compareAt, price) {
    var normalizedCompareAt = readMoneyValue(compareAt, null);
    var normalizedPrice = readMoneyValue(price, null);

    return normalizedCompareAt !== null && normalizedPrice !== null && normalizedCompareAt > normalizedPrice;
  }

  function isVariantOnSale(variant) {
    if (!variant || typeof variant !== 'object') return false;

    return isPriceOnSale([
      variant.compare_at_price,
      variant.compareAtPrice
    ], [
      variant.price
    ]);
  }

  async function getProductSavingsPreview(variantId, maxListLookups) {
    var normalizedVariantId = String(variantId || '').trim();
    if (!normalizedVariantId || !isCustomerLoggedIn) return null;
    if (Object.prototype.hasOwnProperty.call(state.productPreviewCache, normalizedVariantId)) {
      return state.productPreviewCache[normalizedVariantId];
    }

    var lists = [];
    try {
      lists = await fetchLists(false);
    } catch (error) {
      state.productPreviewCache[normalizedVariantId] = null;
      return null;
    }

    if (!Array.isArray(lists) || !lists.length) {
      state.productPreviewCache[normalizedVariantId] = null;
      return null;
    }

    var limit = Math.min(lists.length, Math.max(1, toInteger(maxListLookups, 4)));

    for (var index = 0; index < limit; index += 1) {
      var listSummary = lists[index];
      if (!listSummary || !listSummary.id) continue;

      var fullList = listSummary;
      if (!Array.isArray(fullList.items) || !fullList.items.length) {
        try {
          fullList = await fetchList(listSummary.id);
        } catch (error) {
          continue;
        }
      }

      var matchingItem = (fullList.items || []).find(function (item) {
        return String(item.variantId || '') === normalizedVariantId;
      });
      if (!matchingItem) continue;

      var pct = Number(matchingItem.estimatedReorderDiscountPct || 0);
      var savingsCents = Number(matchingItem.estimatedReorderSavingsCents || matchingItem.estimatedSavingsCents || 0);

      if ((Number.isFinite(pct) && pct > 0) || (Number.isFinite(savingsCents) && savingsCents > 0)) {
        var preview = {
          percent: Number.isFinite(pct) && pct > 0 ? pct : 0,
          savingsCents: Number.isFinite(savingsCents) && savingsCents > 0 ? savingsCents : 0
        };
        state.productPreviewCache[normalizedVariantId] = preview;
        return preview;
      }
    }

    state.productPreviewCache[normalizedVariantId] = null;
    return null;
  }

  async function updateProductCallout(listCount, hasCreatedList) {
    var callout = document.querySelector('[data-product-loyalty-callout]');
    if (!callout) return;
    var inlineContainer = callout.closest('[data-product-loyalty-inline]');
    var markReady = function () {
      callout.setAttribute('data-product-loyalty-state', 'ready');
      callout.setAttribute('aria-busy', 'false');
    };
    var isOnSaleItem = readBooleanValue(callout.getAttribute('data-product-loyalty-on-sale')) === true;

    var renderNonce = ++productCalloutRenderNonce;

    var title = callout.querySelector('.saved-lists-loyalty-callout__title');
    var firstListLine = callout.querySelector('[data-product-loyalty-line-first-list]');
    var reorderLine = callout.querySelector('[data-product-loyalty-line-reorder]');
    var qty2Line = callout.querySelector('[data-product-loyalty-line-qty2]');
    var dynamic = callout.querySelector('[data-product-loyalty-dynamic]');
    var loginUrl = callout.getAttribute('data-product-loyalty-login-url') || buildLoginUrl(getCurrentPath());
    var variantId = callout.getAttribute('data-product-loyalty-variant-id') || '';
    var basePriceCents = readMoneyValue(callout.getAttribute('data-product-loyalty-price'), null);
    var compareAtPriceCents = readMoneyValue(callout.getAttribute('data-product-loyalty-compare-at-price'), null);
    var bulkPriceCents = getVariantBulkPriceCents(callout, variantId);
    var hasOrdered = readBooleanValue(callout.getAttribute('data-product-loyalty-has-ordered')) === true;
    var hasBulkPrice = (
      Number.isFinite(basePriceCents) &&
      Number.isFinite(bulkPriceCents) &&
      bulkPriceCents > 0 &&
      bulkPriceCents < basePriceCents
    );
    var hasEffectiveCompareAt = (
      Number.isFinite(compareAtPriceCents) &&
      Number.isFinite(basePriceCents) &&
      compareAtPriceCents > basePriceCents
    );
    var layoutMode = hasEffectiveCompareAt ? 'stacked' : 'inline';
    var quantity = getProductQuantity(callout);
    var hasQtyTier = quantity >= 2;
    var configuredBulkPriceText = hasBulkPrice ? formatMoney(bulkPriceCents) : '';
    var fallbackBulkPriceText = configuredBulkPriceText || formatDiscountedUnitPrice(basePriceCents, BULK_DISCOUNT_DEFAULT_PCT);
    var firstListReward = null;
    var firstListPriceText = '';
    var message = '';

    callout.setAttribute('data-product-loyalty-layout', layoutMode);
    if (inlineContainer) {
      inlineContainer.setAttribute('data-product-loyalty-layout', layoutMode);
    }

    setElementVisible(inlineContainer, !isOnSaleItem && hasBulkPrice);
    setElementText(title, !state.loyaltyEvaluateEnabled ? 'Bulk pricing' : (hasOrdered ? 'Loyalty savings on this item' : 'Bulk pricing'));
    setElementVisible(firstListLine, false);
    setElementVisible(reorderLine, hasOrdered);
    setElementVisible(qty2Line, !hasQtyTier);

    if (isOnSaleItem || !hasBulkPrice) {
      setElementHtml(dynamic, '');
      markReady();
      return;
    }

    if (!isCustomerLoggedIn) {
      setElementVisible(firstListLine, false);
      setElementVisible(reorderLine, false);
      setElementVisible(qty2Line, !hasQtyTier);

      if (fallbackBulkPriceText) {
        setElementHtml(dynamic, getBulkPriceMessageHtml(fallbackBulkPriceText, hasQtyTier));
      } else {
        setElementHtml(dynamic, '<a href="' + escapeHtml(loginUrl) + '">Sign in</a> to view savings on this item.');
      }
      markReady();
      return;
    }

    if (!variantId) {
      setElementVisible(firstListLine, false);
      setElementVisible(reorderLine, hasOrdered);
      setElementVisible(qty2Line, !hasQtyTier);
      setElementText(dynamic, 'Select a variant to view item-specific savings.');
      markReady();
      return;
    }

    if (!state.loyaltyEvaluateEnabled) {
      setElementVisible(firstListLine, false);
      setElementVisible(reorderLine, false);
      setElementVisible(qty2Line, !hasQtyTier);
      setElementHtml(dynamic, getBulkPriceMessageHtml(fallbackBulkPriceText, hasQtyTier));
      markReady();
      return;
    }

    setElementVisible(reorderLine, hasOrdered);
    setElementVisible(qty2Line, !hasQtyTier);

    if (!hasOrdered) {
      firstListReward = await evaluateFirstListRewardForLine({
        variantId: variantId,
        quantity: quantity,
        basePriceCents: basePriceCents,
        compareAtPriceCents: compareAtPriceCents
      });
      if (renderNonce !== productCalloutRenderNonce) return;
    }

    var preview = null;
    if (hasOrdered) {
      preview = await getProductSavingsPreview(variantId, 12);
      if (renderNonce !== productCalloutRenderNonce) return;
    }

    var loyaltyPct = hasOrdered && preview && preview.percent > 0 ? preview.percent : 0;
    var loyaltyPriceText = loyaltyPct > 0 ? formatDiscountedUnitPrice(basePriceCents, loyaltyPct) : '';
    var firstListPct = firstListReward && firstListReward.applies
      ? Number(firstListReward.discountPct || 0)
      : 0;
    if (firstListPct > 0) {
      firstListPriceText = formatDiscountedUnitPrice(basePriceCents, firstListPct);
    }
    var bulkPct = loyaltyPct > 0 ? loyaltyPct : BULK_DISCOUNT_DEFAULT_PCT;
    var bulkPriceText = configuredBulkPriceText || formatDiscountedUnitPrice(basePriceCents, bulkPct) || fallbackBulkPriceText;
    setElementVisible(firstListLine, !hasOrdered && Boolean(firstListPriceText));

    if (hasOrdered) {
      if (hasQtyTier && bulkPriceText) {
        message = getBulkPriceMessageHtml(bulkPriceText, true);
      } else if (loyaltyPriceText) {
        message = '<strong>' + escapeHtml(loyaltyPriceText) + '</strong> when you re-order this item.';
      } else if (bulkPriceText) {
        message = getBulkPriceMessageHtml(bulkPriceText, false);
      } else {
        message = 'Re-order this item to unlock loyalty savings.';
      }
    } else if (firstListPriceText) {
      message = '<strong>' + escapeHtml(firstListPriceText) + '</strong> with your first list reward.';
    } else if (bulkPriceText) {
      message = getBulkPriceMessageHtml(bulkPriceText, hasQtyTier);
    } else if (firstListReward && firstListReward.eligible === false && firstListReward.reason) {
      message = getIneligibleReasonText(firstListReward.reason);
    } else {
      message = 'No bulk discount currently available on this item.';
    }

    setElementHtml(dynamic, message);
    markReady();
  }

  function removePickupFromAvailabilityText() {
    var timeframeLines = document.querySelectorAll('.product-main .stockStatusBlock .delivery_timeframe');
    if (!timeframeLines.length) return;

    Array.prototype.forEach.call(timeframeLines, function (line) {
      var text = normalizeInlineText(line.textContent || '');
      if (!text) return;

      var updated = text
        .replace(/\s+or\s+pick-?up\s+free\s+at\s+.*$/i, '')
        .replace(/\s+or\s+pick-?up\s+at\s+.*$/i, '')
        .replace(/\s{2,}/g, ' ')
        .trim();

      if (!updated) return;
      if (!/[.!?]$/.test(updated)) updated += '.';
      line.textContent = updated;
    });
  }

  function updateProductAvailabilityAndShippingMessaging() {
    var callout = document.querySelector('[data-product-loyalty-callout]');
    if (!callout) {
      markAvailabilityMessagingReady();
      return;
    }

    var availabilityStatus = normalizeInlineText(callout ? callout.getAttribute('data-product-availability-status') : '').toLowerCase();
    var availabilityBlocks = document.querySelectorAll('.product-main .stockStatusBlock');

    if (!availabilityStatus && availabilityBlocks.length) {
      availabilityStatus = normalizeInlineText(availabilityBlocks[0].getAttribute('data-product-availability-status') || '').toLowerCase();
    }

    var isReadyToShip = availabilityStatus === 'ready_to_ship'
      || availabilityStatus.indexOf('ready_to_ship') !== -1
      || availabilityStatus.indexOf('ready to ship') !== -1
      || availabilityStatus === 'in_stock'
      || availabilityStatus === 'in stock';
    var supplierShippingContext = getSupplierShippingContext(availabilityStatus);
    var dispatchContext = getNzDispatchContext();

    removePickupFromAvailabilityText();

    Array.prototype.forEach.call(availabilityBlocks, function (block) {
      var stockLines = block.querySelectorAll('.stock_status');
      var timeframeLine = block.querySelector('.delivery_timeframe');
      var dispatchLine = block.querySelector('.delivery_days');
      var shouldUseReadyBadge = isReadyToShip && !supplierShippingContext;
      var shouldUseSupplierBadge = Boolean(supplierShippingContext);
      var shouldUseBadgeLayout = shouldUseReadyBadge || shouldUseSupplierBadge;
      var statusLabel = shouldUseReadyBadge
        ? 'In stock'
        : (supplierShippingContext && supplierShippingContext.stockLabel ? supplierShippingContext.stockLabel : '');
      var originalTimeframe = '';
      var originalDispatchDays = '';

      if (availabilityStatus) {
        block.setAttribute('data-product-availability-status', availabilityStatus);
      }

      block.classList.toggle('stockStatusBlock--badge-layout', shouldUseBadgeLayout);
      block.classList.toggle('stockStatusBlock--ready-to-ship', shouldUseReadyBadge);
      block.classList.toggle('stockStatusBlock--supplier', shouldUseSupplierBadge);

      Array.prototype.forEach.call(stockLines, function (line) {
        var originalStatus = line.getAttribute('data-original-stock-status');
        if (!originalStatus) {
          originalStatus = normalizeInlineText(line.textContent || '');
          line.setAttribute('data-original-stock-status', originalStatus);
        }

        if (statusLabel) {
          line.textContent = statusLabel;
          return;
        }

        if (originalStatus) {
          line.textContent = originalStatus;
        }
      });

      if (timeframeLine) {
        originalTimeframe = timeframeLine.getAttribute('data-original-delivery-timeframe');
        if (!originalTimeframe) {
          originalTimeframe = normalizeInlineText(timeframeLine.textContent || '');
          timeframeLine.setAttribute('data-original-delivery-timeframe', originalTimeframe);
        }

        if (shouldUseReadyBadge) {
          var readyEtaText = dispatchContext ? getCompactEtaText(dispatchContext.etaLine) : '';
          timeframeLine.textContent = readyEtaText || 'Estimated delivery timeframe shown at checkout.';
        } else if (supplierShippingContext && supplierShippingContext.timeframeText) {
          timeframeLine.textContent = supplierShippingContext.timeframeText;
        } else if (originalTimeframe) {
          timeframeLine.textContent = originalTimeframe;
        }
      }

      if (!dispatchLine) return;

      originalDispatchDays = dispatchLine.getAttribute('data-original-delivery-days');
      if (!originalDispatchDays) {
        originalDispatchDays = normalizeInlineText(dispatchLine.textContent || '');
        dispatchLine.setAttribute('data-original-delivery-days', originalDispatchDays);
      }

      if (shouldUseReadyBadge) {
        dispatchLine.textContent = originalTimeframe || originalDispatchDays || '';
        dispatchLine.classList.add('delivery_days--subdued');
      } else if (supplierShippingContext && supplierShippingContext.detailText) {
        dispatchLine.textContent = supplierShippingContext.detailText;
        dispatchLine.classList.remove('delivery_days--subdued');
      } else if (originalDispatchDays) {
        dispatchLine.textContent = originalDispatchDays;
        dispatchLine.classList.remove('delivery_days--subdued');
      } else {
        dispatchLine.textContent = '';
        dispatchLine.classList.remove('delivery_days--subdued');
      }

      if (normalizeInlineText(dispatchLine.textContent || '')) {
        dispatchLine.removeAttribute('hidden');
      } else {
        dispatchLine.setAttribute('hidden', 'hidden');
      }
    });

    var shippingBlock = document.querySelector('.product-main .product-post-atc-meta__card--shipping .shippingBlock');
    if (!shippingBlock) {
      markAvailabilityMessagingReady();
      return;
    }

    var etaLine = shippingBlock.querySelector('[data-shipping-eta]');
    if (etaLine) {
      etaLine.remove();
    }

    markAvailabilityMessagingReady();
  }

  function bindProductCalloutEvents() {
    var callout = document.querySelector('[data-product-loyalty-callout]');
    if (!callout) return;
    if (callout.getAttribute('data-product-loyalty-bound') === 'true') return;
    callout.setAttribute('data-product-loyalty-bound', 'true');

    var scope = callout.closest('.product--outer') || document;
    var refreshFromQuantity = function () {
      setProductCalloutLoading(callout);
      updateProductCallout(loyaltyContextListCount, loyaltyContextHasCreatedList).catch(function () {
        // Ignore callout refresh failures from live quantity edits.
      });
    };

    scope.addEventListener('input', function (event) {
      if (event.target && event.target.matches('input[name="quantity"]')) {
        refreshFromQuantity();
      }
    });

    scope.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[name="quantity"]')) {
        refreshFromQuantity();
      }
    });

    scope.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest('[data-quantity-plus], [data-quantity-minus]')) return;

      window.requestAnimationFrame(function () {
        refreshFromQuantity();
      });
    });

    var syncCalloutVariantState = function (variant, options) {
      var opts = options || {};
      var availabilityBlocks = scope.querySelectorAll('[data-product-availability-block]');

      if (variant && variant.id) {
        var nextAvailabilityStatus = getVariantAvailabilityStatus(callout, variant.id);

        callout.setAttribute('data-product-loyalty-variant-id', String(variant.id));
        callout.setAttribute('data-product-loyalty-price', variant.price != null ? String(variant.price) : '');
        callout.setAttribute('data-product-loyalty-compare-at-price', variant.compare_at_price != null ? String(variant.compare_at_price) : '');
        callout.setAttribute('data-product-loyalty-on-sale', isVariantOnSale(variant) ? 'true' : 'false');

        if (nextAvailabilityStatus) {
          callout.setAttribute('data-product-availability-status', nextAvailabilityStatus);

          Array.prototype.forEach.call(availabilityBlocks, function (block) {
            block.setAttribute('data-product-availability-status', nextAvailabilityStatus);
          });
        }
      } else {
        callout.setAttribute('data-product-loyalty-variant-id', '');
        callout.setAttribute('data-product-loyalty-price', '');
        callout.setAttribute('data-product-loyalty-compare-at-price', '');
        callout.setAttribute('data-product-loyalty-on-sale', 'false');
      }

      if (opts.showLoading) {
        setProductCalloutLoading(callout);
      }

      updateProductAvailabilityAndShippingMessaging();

      updateProductCallout(loyaltyContextListCount, loyaltyContextHasCreatedList).catch(function () {
        // Ignore callout refresh failures from variant state sync.
      });
    };

    var variantSelections = scope.querySelectorAll('[data-variant-selection]');
    Array.prototype.forEach.call(variantSelections, function (variantSelection) {
      variantSelection.addEventListener('variant-change', function (event) {
        var detail = event && event.detail ? event.detail : {};
        var variant = detail && detail.variant ? detail.variant : null;

        syncCalloutVariantState(variant, { showLoading: true });
      });

      if (typeof variantSelection.getVariant === 'function') {
        variantSelection.getVariant().then(function (variant) {
          syncCalloutVariantState(variant);
        }).catch(function () {
          // Ignore initial variant sync failures.
        });
      }
    });
  }

  async function refreshLoyaltyContextCallouts(options) {
    var opts = options || {};
    var listCount = 0;

    try {
      listCount = await getCustomerListCount(Boolean(opts.forceListFetch));
    } catch (error) {
      listCount = 0;
    }

    var hasCreatedList = hasCreatedListForContext(listCount);
    loyaltyContextListCount = listCount;
    loyaltyContextHasCreatedList = hasCreatedList;

    updateSavedListsCallout(listCount, hasCreatedList);
    updateOrdersCallout(listCount, hasCreatedList);
    await updateProductCallout(listCount, hasCreatedList);
  }

  async function fetchList(listId) {
    var payload = await api('/lists/' + encodeURIComponent(listId));
    var normalized = normalizeList(getListFromPayload(payload));

    var listIndex = state.lists.findIndex(function (list) {
      return list.id === normalized.id;
    });

    if (listIndex !== -1) {
      state.lists[listIndex] = normalized;
    }

    return normalized;
  }

  async function createList(name) {
    var listName = sanitizeListName(name);
    if (!listName) {
      throw new Error('List name is required.');
    }

    var payload = await api('/lists', {
      method: 'POST',
      body: { name: listName }
    });

    var created = normalizeList(payload.list || payload.data || payload);

    if (created.id) {
      state.lists.unshift(created);
      state.listsLoadedAt = Date.now();
      state.productPreviewCache = {};
      markCustomerHasCreatedList();
      customerListCountPromise = Promise.resolve(state.lists.length);
      refreshLoyaltyContextCallouts();
    }

    return created;
  }

  async function updateListName(listId, name) {
    var listName = sanitizeListName(name);
    if (!listName) {
      throw new Error('List name is required.');
    }

    var payload = await api('/lists/' + encodeURIComponent(listId), {
      method: 'PATCH',
      body: { name: listName }
    });

    var payloadList = getListFromPayload(payload) || {};
    var finalName = sanitizeListName(payloadList.name || listName) || listName;
    var idText = String(listId);

    var listIndex = state.lists.findIndex(function (list) {
      return list.id === idText;
    });

    if (listIndex !== -1) {
      state.lists[listIndex].name = finalName;
    }

    if (state.activeList && state.activeList.id === idText) {
      state.activeList.name = finalName;
    }

    state.listsLoadedAt = Date.now();

    return {
      id: idText,
      name: finalName
    };
  }

  async function addItemToList(listId, variantId, quantity) {
    return api('/lists/' + encodeURIComponent(listId) + '/items', {
      method: 'POST',
      body: {
        variant_id: Number(variantId),
        quantity: Number(quantity)
      }
    });
  }

  async function updateListItem(listId, variantId, quantity) {
    return api('/lists/' + encodeURIComponent(listId) + '/items/' + encodeURIComponent(variantId), {
      method: 'PATCH',
      body: {
        quantity: Number(quantity)
      }
    });
  }

  async function deleteListItem(listId, variantId) {
    return api('/lists/' + encodeURIComponent(listId) + '/items/' + encodeURIComponent(variantId), {
      method: 'DELETE'
    });
  }

  async function deleteList(listId) {
    await api('/lists/' + encodeURIComponent(listId), {
      method: 'DELETE'
    });

    var idText = String(listId);
    state.lists = (state.lists || []).filter(function (list) {
      return list.id !== idText;
    });

    if (state.activeList && state.activeList.id === idText) {
      state.activeList = null;
    }

    state.listsLoadedAt = Date.now();
    state.productPreviewCache = {};
    customerListCountPromise = Promise.resolve(state.lists.length);
    refreshLoyaltyContextCallouts();
    return true;
  }

  function cartAddUrl() {
    var url = config.cartAddUrl || '/cart/add';
    return /\.js$/.test(url) ? url : url + '.js';
  }

  function cartDataUrl() {
    var url = config.cartUrl || '/cart';
    return /\.js$/.test(url) ? url : url + '.js';
  }

  async function updateHeaderCartCount() {
    var response = await fetch(cartDataUrl(), {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    });

    if (!response.ok) return;

    var cart = await response.json();
    window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
  }

  async function addItemsToCart(items) {
    var sourceItems = Array.isArray(items) ? items : [];
    var evaluationItems = sourceItems
      .map(function (item) {
        var normalized = {
          id: toInteger(item.id || item.variantId, 0),
          quantity: toInteger(item.quantity, 1)
        };
        var priceCents = readMoneyValue([
          item && item.price,
          item && item.price_cents,
          item && item.priceCents
        ], null);
        var compareAtPriceCents = readMoneyValue([
          item && item.compare_at_price,
          item && item.compareAtPrice,
          item && item.compareAtPriceCents
        ], null);

        if (item && item.properties && typeof item.properties === 'object') {
          var propertyKeys = Object.keys(item.properties);
          if (propertyKeys.length) {
            normalized.properties = {};
            propertyKeys.forEach(function (key) {
              normalized.properties[key] = String(item.properties[key]);
            });
          }
        }
        if (priceCents !== null) {
          normalized.price = Math.max(0, Math.round(priceCents));
        }
        if (compareAtPriceCents !== null) {
          normalized.compare_at_price = Math.max(0, Math.round(compareAtPriceCents));
        }

        return normalized;
      })
      .filter(function (item) {
        return item.id > 0 && item.quantity > 0;
      });

    var validItems = evaluationItems.map(function (item) {
      var normalized = {
        id: item.id,
        quantity: item.quantity
      };

      if (item.properties && typeof item.properties === 'object' && Object.keys(item.properties).length) {
        normalized.properties = Object.assign({}, item.properties);
      }

      return normalized;
    });

    if (!validItems.length) {
      throw new Error('No valid products found to add to cart.');
    }

    var loyaltyPreviewPromise = null;
    if (state.loyaltyEvaluateEnabled && isCustomerLoggedIn) {
      loyaltyPreviewPromise = evaluateLoyaltyForCartItems(evaluationItems);
    }

    var response = await fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: validItems })
    });

    var payload = await parseResponse(response);

    if (!response.ok || (payload && payload.message === 'Cart Error')) {
      var message = payload && (payload.description || payload.message);
      throw new Error(message || 'Unable to add items to cart.');
    }

    await updateHeaderCartCount();
    var loyaltyPreview = null;
    if (loyaltyPreviewPromise) {
      loyaltyPreview = await loyaltyPreviewPromise;
    }

    if (payload && typeof payload === 'object') {
      payload.loyaltyPreview = loyaltyPreview;
      return payload;
    }

    return {
      data: payload,
      loyaltyPreview: loyaltyPreview
    };
  }

  function showMessage(el, message, type) {
    if (!el) return;

    if (!message) {
      el.hidden = true;
      el.textContent = '';
      el.className = 'saved-lists-message';
      return;
    }

    el.hidden = false;
    el.textContent = message;
    el.className = 'saved-lists-message saved-lists-message--' + (type || 'success');
  }

  function showToast(message, type) {
    var toast = document.createElement('div');
    toast.className = 'saved-lists-message saved-lists-message--' + (type || 'success');
    toast.style.bottom = '16px';
    toast.style.left = '50%';
    toast.style.maxWidth = '440px';
    toast.style.position = 'fixed';
    toast.style.transform = 'translateX(-50%)';
    toast.style.zIndex = '90';
    toast.textContent = message;

    document.body.appendChild(toast);

    window.setTimeout(function () {
      toast.remove();
    }, 2800);
  }

  function buildLoyaltyAddToCartMessage(baseMessage, preview) {
    return normalizeInlineText(baseMessage || 'Items added to cart.');
  }

  function resolveVariantId(trigger) {
    if (!trigger) return '';

    var scopedParent = trigger.closest('.product--outer, .product__container, .productitem, .modal-content, .modal');

    if (scopedParent) {
      var input = scopedParent.querySelector('[data-product-form] [data-variants], form[action*="/cart/add"] [name="id"], [data-variants]');
      if (input && input.value && input.value !== 'not-selected') {
        return input.value;
      }
    }

    var explicitId = trigger.getAttribute('data-variant-id');
    if (explicitId && explicitId !== 'not-selected') return explicitId;

    return '';
  }

  function ensureHeartModal() {
    if (state.heartModal) return state.heartModal;

    var root = document.createElement('div');
    root.className = 'saved-lists-modal';
    root.setAttribute('data-saved-lists-modal', '');
    root.hidden = true;

    root.innerHTML = [
      '<div class="saved-lists-modal__backdrop" data-saved-lists-modal-close></div>',
      '<div class="saved-lists-modal__dialog" role="dialog" aria-modal="true" aria-label="Saved lists">',
      '  <button type="button" class="saved-lists-modal__close" data-saved-lists-modal-close aria-label="Close">&times;</button>',
      '  <h3 class="saved-lists-modal__title">Add to saved list</h3>',
      '  <span class="saved-lists-modal__product-title" data-saved-lists-modal-product-title></span>',
      '  <div class="saved-lists-message" data-saved-lists-modal-message hidden></div>',
      '  <div class="saved-lists-modal__field-row">',
      '    <label for="saved-lists-modal-qty" class="visually-hidden">Quantity</label>',
      '    <input id="saved-lists-modal-qty" class="form-field-input saved-lists-modal__qty-input" type="number" min="1" value="1" data-saved-lists-modal-qty>',
      '  </div>',
      '  <div class="saved-lists-modal__lists" data-saved-lists-modal-lists></div>',
      '  <div class="saved-lists-modal__actions">',
      '    <button type="button" class="button-primary" data-saved-lists-modal-add>Add to selected list</button>',
      '  </div>',
      '  <hr class="saved-lists-modal__divider">',
      '  <div class="saved-lists-modal__field-row">',
      '    <label for="saved-lists-modal-new-name" class="visually-hidden">List name</label>',
      '    <input id="saved-lists-modal-new-name" class="form-field-input saved-lists-modal__create-input" type="text" maxlength="' + String(LIST_NAME_MAX_LENGTH) + '" placeholder="Type a list name" data-saved-lists-modal-new-name>',
      '    <button type="button" class="button-secondary" data-saved-lists-modal-create>Create list</button>',
      '  </div>',
      '</div>'
    ].join('');

    document.body.appendChild(root);

    var modal = {
      root: root,
      message: root.querySelector('[data-saved-lists-modal-message]'),
      productTitle: root.querySelector('[data-saved-lists-modal-product-title]'),
      qtyInput: root.querySelector('[data-saved-lists-modal-qty]'),
      listsContainer: root.querySelector('[data-saved-lists-modal-lists]'),
      addButton: root.querySelector('[data-saved-lists-modal-add]'),
      createButton: root.querySelector('[data-saved-lists-modal-create]'),
      createInput: root.querySelector('[data-saved-lists-modal-new-name]')
    };

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-saved-lists-modal-close]')) {
        hideHeartModal();
      }
    });

    modal.addButton.addEventListener('click', onModalAddToList);
    modal.createButton.addEventListener('click', onModalCreateAndAdd);
    modal.createInput.addEventListener('input', syncHeartModalCreateState);
    modal.createInput.addEventListener('change', syncHeartModalCreateState);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.root.hidden) {
        hideHeartModal();
      }
    });

    state.heartModal = modal;
    syncHeartModalCreateState();
    return modal;
  }

  function syncHeartModalCreateState() {
    if (!state.heartModal) return;
    if (state.heartModal.createInput.disabled) return;

    state.heartModal.createButton.disabled = String(state.heartModal.createInput.value || '').trim().length < 1;
  }

  function renderModalLists(lists) {
    var modal = ensureHeartModal();

    if (!lists.length) {
      modal.listsContainer.innerHTML = '<p class="saved-lists-modal__empty">No saved lists yet. Create one below.</p>';
      modal.addButton.disabled = true;
      return;
    }

    modal.addButton.disabled = false;

    modal.listsContainer.innerHTML = lists
      .map(function (list, index) {
        var checked = index === 0 ? 'checked' : '';
        var fullListName = normalizeInlineText(list.name || 'Untitled list');
        var displayListName = truncateTitle(fullListName, CARD_TITLE_MAX_LENGTH);

        return [
          '<label class="saved-lists-modal__list-option" title="' + escapeHtml(fullListName) + '">',
          '  <span><input type="radio" name="saved-lists-modal-list" value="' + escapeHtml(list.id) + '" ' + checked + '> ' + escapeHtml(displayListName) + '</span>',
          '  <span class="saved-lists-modal__list-count">' + escapeHtml(String(list.itemCount || 0)) + ' items</span>',
          '</label>'
        ].join('');
      })
      .join('');
  }

  function hideHeartModal() {
    if (!state.heartModal) return;

    setRegionBusy(state.heartModal.root, false);
    state.heartModal.root.hidden = true;
    setSavedListsModalBodyState(false);
    showMessage(state.heartModal.message, '');
    state.heartContext = null;
  }

  function ensureOrderListNameModal() {
    if (state.orderListNameModal) return state.orderListNameModal;

    var root = document.createElement('div');
    root.className = 'saved-lists-modal';
    root.setAttribute('data-saved-lists-order-name-modal', '');
    root.hidden = true;

    root.innerHTML = [
      '<div class="saved-lists-modal__backdrop" data-saved-lists-order-name-modal-close></div>',
      '<div class="saved-lists-modal__dialog" role="dialog" aria-modal="true" aria-label="Create list from order" data-saved-lists-order-name-modal-dialog>',
      '  <button type="button" class="saved-lists-modal__close" data-saved-lists-order-name-modal-close aria-label="Close">&times;</button>',
      '  <h3 class="saved-lists-modal__title" data-saved-lists-order-name-modal-title>Create list from order</h3>',
      '  <div class="saved-lists-message" data-saved-lists-order-name-modal-message hidden></div>',
      '  <div class="saved-lists-modal__field-row">',
      '    <label for="saved-lists-order-name-modal-input" class="visually-hidden">List name</label>',
      '    <input id="saved-lists-order-name-modal-input" class="form-field-input" type="text" maxlength="' + String(LIST_NAME_MAX_LENGTH) + '" placeholder="Type a list name" data-saved-lists-order-name-modal-input>',
      '  </div>',
      '  <div class="saved-lists-modal__actions">',
      '    <button type="button" class="button-secondary" data-saved-lists-order-name-modal-cancel>Cancel</button>',
      '    <button type="button" class="button-primary" data-saved-lists-order-name-modal-submit>Create list</button>',
      '  </div>',
      '</div>'
    ].join('');

    document.body.appendChild(root);

    var modal = {
      root: root,
      dialog: root.querySelector('[data-saved-lists-order-name-modal-dialog]'),
      title: root.querySelector('[data-saved-lists-order-name-modal-title]'),
      message: root.querySelector('[data-saved-lists-order-name-modal-message]'),
      input: root.querySelector('[data-saved-lists-order-name-modal-input]'),
      submitButton: root.querySelector('[data-saved-lists-order-name-modal-submit]'),
      pendingResolve: null
    };

    function closeOrderListNameModal(value) {
      modal.root.hidden = true;
      setSavedListsModalBodyState(false);
      showMessage(modal.message, '');
      modal.submitButton.disabled = false;

      var resolve = modal.pendingResolve;
      modal.pendingResolve = null;
      if (resolve) resolve(value);
    }

    function submitOrderListNameModal() {
      var listName = sanitizeListName(modal.input.value || '');
      modal.input.value = listName;

      if (!listName) {
        showMessage(modal.message, 'Enter a list name.', 'error');
        modal.input.focus();
        return;
      }

      closeOrderListNameModal(listName);
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-saved-lists-order-name-modal-close], [data-saved-lists-order-name-modal-cancel]')) {
        closeOrderListNameModal(null);
      }
    });

    modal.submitButton.addEventListener('click', submitOrderListNameModal);

    modal.input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        submitOrderListNameModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.root.hidden) {
        closeOrderListNameModal(null);
      }
    });

    modal.request = function (defaultName, options) {
      var opts = options || {};
      var modalTitle = normalizeInlineText(opts.title || 'Create list from order') || 'Create list from order';
      var submitLabel = normalizeInlineText(opts.submitLabel || 'Create list') || 'Create list';
      var ariaLabel = normalizeInlineText(opts.ariaLabel || modalTitle) || modalTitle;

      if (modal.pendingResolve) {
        var previousResolve = modal.pendingResolve;
        modal.pendingResolve = null;
        previousResolve(null);
      }

      if (modal.title) modal.title.textContent = modalTitle;
      if (modal.submitButton) modal.submitButton.textContent = submitLabel;
      if (modal.dialog) modal.dialog.setAttribute('aria-label', ariaLabel);

      modal.input.value = sanitizeListName(defaultName || '');
      showMessage(modal.message, '');
      modal.root.hidden = false;
      setSavedListsModalBodyState(true);

      window.setTimeout(function () {
        modal.input.focus();
        modal.input.select();
      }, 0);

      return new Promise(function (resolve) {
        modal.pendingResolve = resolve;
      });
    };

    state.orderListNameModal = modal;
    return modal;
  }

  async function requestOrderListName(defaultName) {
    var modal = ensureOrderListNameModal();
    return modal.request(defaultName, {
      title: 'Create list from order',
      submitLabel: 'Create list',
      ariaLabel: 'Create list from order'
    });
  }

  async function requestRenameListName(defaultName) {
    var modal = ensureOrderListNameModal();
    return modal.request(defaultName, {
      title: 'Rename list',
      submitLabel: 'Save name',
      ariaLabel: 'Rename list'
    });
  }

  async function openHeartModal(trigger) {
    if (!isCustomerLoggedIn) {
      redirectToLogin(getCurrentPath());
      return;
    }

    var variantId = resolveVariantId(trigger);

    if (!variantId || variantId === '0') {
      showToast('Select a product variant first.', 'error');
      return;
    }

    var modal = ensureHeartModal();
    var fullProductTitle = normalizeInlineText(trigger.getAttribute('data-product-title') || 'Product') || 'Product';
    if (trigger && typeof trigger.blur === 'function') {
      trigger.blur();
    }

    state.heartContext = {
      variantId: variantId,
      productTitle: fullProductTitle
    };

    modal.productTitle.textContent = truncateTitle(fullProductTitle, MODAL_TITLE_MAX_LENGTH);
    modal.productTitle.setAttribute('title', fullProductTitle);
    modal.qtyInput.value = '1';
    modal.createInput.value = '';
    modal.createInput.disabled = false;
    modal.listsContainer.innerHTML = '<p class="saved-lists-modal__empty">Loading saved lists...</p>';
    syncHeartModalCreateState();
    showMessage(modal.message, '');
    modal.root.hidden = false;
    setSavedListsModalBodyState(true);
    setRegionBusy(modal.root, true);

    var stopModalListLoading = beginButtonLoading(modal.addButton, 'Loading...');

    try {
      var lists = await fetchLists();
      renderModalLists(lists);
    } catch (error) {
      renderModalLists([]);
      showMessage(modal.message, error.message || 'Unable to load saved lists.', 'error');
    } finally {
      stopModalListLoading({ keepDisabled: modal.addButton.disabled });
      setRegionBusy(modal.root, false);
    }
  }

  function selectedModalListId() {
    if (!state.heartModal) return '';

    var selected = state.heartModal.root.querySelector('input[name="saved-lists-modal-list"]:checked');
    return selected ? selected.value : '';
  }

  async function onModalAddToList() {
    var modal = ensureHeartModal();
    var listId = selectedModalListId();

    if (!listId) {
      showMessage(modal.message, 'Select a list first.', 'error');
      return;
    }

    var qty = toInteger(modal.qtyInput.value, 1);
    if (qty < 1) qty = 1;

    var stopModalSaveLoading = beginButtonLoading(modal.addButton, 'Saving...');

    try {
      await addItemToList(listId, state.heartContext.variantId, qty);
      await fetchLists(true);
      refreshLoyaltyContextCallouts();
      showMessage(modal.message, 'Saved to list.', 'success');
      showToast('Saved to list.', 'success');
    } catch (error) {
      showMessage(modal.message, error.message || 'Unable to save product.', 'error');
    } finally {
      var hasListOptions = Boolean(modal.root.querySelector('input[name="saved-lists-modal-list"]'));
      stopModalSaveLoading({ keepDisabled: !hasListOptions });
    }
  }

  async function onModalCreateAndAdd() {
    var modal = ensureHeartModal();
    var listName = sanitizeListName(modal.createInput.value || '');
    modal.createInput.value = listName;

    if (!listName) {
      showMessage(modal.message, 'Enter a list name.', 'error');
      syncHeartModalCreateState();
      return;
    }

    var qty = toInteger(modal.qtyInput.value, 1);
    if (qty < 1) qty = 1;

    var stopModalCreateLoading = beginButtonLoading(modal.createButton, 'Creating...');

    try {
      modal.createInput.disabled = true;
      var newList = await createList(listName);
      await addItemToList(newList.id, state.heartContext.variantId, qty);
      var lists = await fetchLists(true);
      renderModalLists(lists);
      refreshLoyaltyContextCallouts();
      showMessage(modal.message, 'New list created and updated.', 'success');
      showToast('Saved to new list.', 'success');
      modal.createInput.value = '';
    } catch (error) {
      showMessage(modal.message, error.message || 'Unable to create list.', 'error');
    } finally {
      stopModalCreateLoading();
      modal.createInput.disabled = false;
      syncHeartModalCreateState();
    }
  }

  function buildLoyaltyCartProperties(options) {
    var opts = options || {};
    var properties = {};

    if (opts.source) properties._saved_lists_source = String(opts.source);
    if (opts.listId) properties._saved_lists_list_id = String(opts.listId);
    if (opts.orderId) properties._saved_lists_order_id = String(opts.orderId);

    return Object.keys(properties).length ? properties : null;
  }

  function mapItemsForCart(items, filterVariantIds, sourceMetadata) {
    var selected = Array.isArray(filterVariantIds) && filterVariantIds.length
      ? new Set(filterVariantIds.map(String))
      : null;
    var properties = buildLoyaltyCartProperties(sourceMetadata);

    return (items || [])
      .filter(function (item) {
        return !selected || selected.has(String(item.variantId));
      })
      .map(function (item) {
        var mapped = {
          id: item.variantId,
          quantity: item.quantity
        };
        var priceCents = readMoneyValue([
          item && item.price,
          item && item.price_cents,
          item && item.priceCents
        ], null);
        var compareAtPriceCents = readMoneyValue([
          item && item.compare_at_price,
          item && item.compareAtPrice,
          item && item.compareAtPriceCents
        ], null);

        if (priceCents !== null) {
          mapped.price = Math.max(0, Math.round(priceCents));
        }
        if (compareAtPriceCents !== null) {
          mapped.compare_at_price = Math.max(0, Math.round(compareAtPriceCents));
        }

        if (properties) {
          mapped.properties = Object.assign({}, properties);
        }

        return mapped;
      });
  }

  function getPageRefs(root) {
    return {
      root: root,
      listView: root.querySelector('[data-saved-lists-list-view]'),
      itemView: root.querySelector('[data-saved-lists-item-view]'),
      message: root.querySelector('[data-saved-lists-message]'),
      loading: root.querySelector('[data-saved-lists-loading]'),
      emptyLists: root.querySelector('[data-saved-lists-lists-empty]'),
      listGrid: root.querySelector('[data-saved-lists-list-grid]'),
      filterInput: root.querySelector('[data-saved-lists-filter-input]'),
      createForm: root.querySelector('[data-saved-lists-create-form]'),
      backButton: root.querySelector('[data-saved-lists-back]'),
      activeName: root.querySelector('[data-saved-lists-active-name]'),
      itemsTable: root.querySelector('.saved-lists-items-table'),
      itemsBody: root.querySelector('[data-saved-lists-items-body]'),
      itemsEmpty: root.querySelector('[data-saved-lists-items-empty]'),
      selectAll: root.querySelector('[data-saved-lists-select-all]'),
      renameListButton: root.querySelector('[data-saved-lists-rename-list]'),
      addListToCart: root.querySelector('[data-saved-lists-add-list-to-cart]'),
      addSelectedToCart: root.querySelector('[data-saved-lists-add-selected-to-cart]'),
      estimatedSavingsSummary: root.querySelector('[data-saved-lists-estimated-summary]'),
      estimatedSavingsTotal: root.querySelector('[data-saved-lists-estimated-total]'),
      estimatedSavingsSelectedRow: root.querySelector('[data-saved-lists-estimated-selected-row]'),
      estimatedSavingsSelected: root.querySelector('[data-saved-lists-estimated-selected]')
    };
  }

  function setListsLoading(isLoading) {
    if (!state.page) return;
    if (state.page.loading) {
      state.page.loading.hidden = !Boolean(isLoading);
    }
    setRegionBusy(state.page.listView, Boolean(isLoading));
  }

  function sumEstimatedSavings(items, variantIdFilter) {
    var entries = Array.isArray(items) ? items : [];
    var filterSet = variantIdFilter instanceof Set ? variantIdFilter : null;

    return entries.reduce(function (total, item) {
      if (!item) return total;

      if (filterSet && !filterSet.has(String(item.variantId || ''))) {
        return total;
      }

      var liveSavings = readMoneyValue([
        item && item.liveSavingsCents
      ], null);
      var estimated = Number(item && item.estimatedSavingsCents || 0);
      var savings = liveSavings !== null
        ? Math.max(0, Math.round(liveSavings))
        : (Number.isFinite(estimated) ? Math.max(0, Math.round(estimated)) : 0);

      if (savings <= 0) {
        return total;
      }

      return total + savings;
    }, 0);
  }

  function updateEstimatedSavingsSummary() {
    if (!state.page) return;

    var refs = state.page;
    var summary = refs.estimatedSavingsSummary;
    if (!summary) return;

    if (!state.activeList || !Array.isArray(state.activeList.items) || !state.activeList.items.length) {
      summary.hidden = true;
      if (refs.estimatedSavingsSelectedRow) refs.estimatedSavingsSelectedRow.hidden = true;
      return;
    }

    var listItems = state.activeList.items;
    var totalEstimatedSavings = sumEstimatedSavings(listItems);
    var checked = refs.itemsBody
      ? refs.itemsBody.querySelectorAll('[data-saved-lists-item-select]:checked')
      : [];
    var selectedVariantIds = new Set(
      Array.prototype.slice.call(checked).map(function (checkbox) {
        var row = checkbox.closest('[data-saved-lists-item-row]');
        return row ? String(row.getAttribute('data-variant-id') || '') : '';
      }).filter(Boolean)
    );
    var selectedEstimatedSavings = selectedVariantIds.size
      ? sumEstimatedSavings(listItems, selectedVariantIds)
      : 0;

    var hasEstimatedSavings = totalEstimatedSavings > 0 || selectedEstimatedSavings > 0;
    summary.hidden = !hasEstimatedSavings;

    if (!hasEstimatedSavings) {
      if (refs.estimatedSavingsSelectedRow) refs.estimatedSavingsSelectedRow.hidden = true;
      return;
    }

    if (refs.estimatedSavingsTotal) {
      refs.estimatedSavingsTotal.textContent = formatMoney(totalEstimatedSavings);
    }

    if (refs.estimatedSavingsSelectedRow) {
      refs.estimatedSavingsSelectedRow.hidden = !(selectedVariantIds.size > 0 && selectedEstimatedSavings > 0);
    }

    if (refs.estimatedSavingsSelected) {
      refs.estimatedSavingsSelected.textContent = formatMoney(selectedEstimatedSavings);
    }
  }

  function updateBulkActionState() {
    if (!state.page || !state.activeList) return;

    var refs = state.page;
    var selected = refs.itemsBody.querySelectorAll('[data-saved-lists-item-select]:checked');
    var itemRows = refs.itemsBody.querySelectorAll('[data-saved-lists-item-select]');
    var hasSelected = selected.length > 0;

    refs.addSelectedToCart.disabled = !hasSelected;
    refs.addSelectedToCart.classList.toggle('disabled', !hasSelected);

    if (refs.selectAll) {
      refs.selectAll.checked = hasSelected && selected.length === itemRows.length;
    }

    updateEstimatedSavingsSummary();
  }

  function renderListCards() {
    var refs = state.page;
    var allLists = state.lists || [];
    var filterText = refs && refs.filterInput
      ? normalizeInlineText(refs.filterInput.value || '').toLowerCase()
      : '';
    var lists = filterText
      ? allLists.filter(function (list) {
        return normalizeInlineText(list.name || '').toLowerCase().indexOf(filterText) !== -1;
      })
      : allLists;

    if (!refs) return;

    refs.listGrid.innerHTML = lists
      .map(function (list) {
        var fullListName = normalizeInlineText(list.name || 'Untitled list') || 'Untitled list';
        var displayListName = truncateTitle(fullListName, CARD_TITLE_MAX_LENGTH);

        return [
          '<article class="saved-lists-list-card saved-lists-list-card--clickable" data-saved-list-id="' + escapeHtml(list.id) + '" tabindex="0" role="button" aria-label="Open list ' + escapeHtml(fullListName) + '">',
          '  <h3 title="' + escapeHtml(fullListName) + '">' + escapeHtml(displayListName) + '</h3>',
          '  <p class="saved-lists-list-card__meta">' + escapeHtml(String(list.itemCount || 0)) + ' items</p>',
          '  <div class="saved-lists-list-card__actions">',
          '    <button type="button" class="button-secondary" data-saved-list-action="add-to-cart">Add list to cart</button>',
          '    <button type="button" class="button-secondary saved-lists-line-actions__remove saved-lists-list-card__delete" data-saved-list-action="delete" aria-label="Delete list ' + escapeHtml(fullListName) + '" title="Delete list">',
          '      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">',
          '        <path d="M3 6h18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>',
          '        <path d="M8 6V4h8v2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>',
          '        <path d="M6 6l1 14h10l1-14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"></path>',
          '        <path d="M10 10v7M14 10v7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>',
          '      </svg>',
          '    </button>',
          '  </div>',
          '</article>'
        ].join('');
      })
      .join('');

    refs.emptyLists.hidden = lists.length > 0;
    refs.emptyLists.textContent = allLists.length > 0 ? 'No matching lists.' : 'No saved lists yet.';
  }

  function buildListItemSavingsMeta(item) {
    return '';
  }

  function buildSavedListItemPriceMeta(item) {
    var priceCents = readMoneyValue([
      item && item.price,
      item && item.price_cents,
      item && item.priceCents
    ], null);
    var compareAtPriceCents = readMoneyValue([
      item && item.compareAtPrice,
      item && item.compare_at_price,
      item && item.compareAtPriceCents,
      item && item.compare_at_price_cents
    ], null);

    if (priceCents === null || priceCents <= 0) return '';

    var isOnSale = isPriceOnSale(compareAtPriceCents, priceCents);
    var compareAtMarkup = '';

    if (isOnSale) {
      compareAtMarkup = [
        '<div class="price__compare-at visible">',
        '  <span class="visually-hidden">Original price</span>',
        '  <span class="money">' + escapeHtml(formatMoney(compareAtPriceCents)) + '</span>',
        '</div>'
      ].join('');
    }

    return [
      '<div class="saved-lists-item-product-price">',
      '  <div class="price">',
      '    ' + compareAtMarkup,
      '    <div class="price__current' + (isOnSale ? ' price__current--on-sale' : '') + '">',
      '      ' + (isOnSale ? '<span class="visually-hidden">Sale price</span>' : ''),
      '      <span class="money">' + escapeHtml(formatMoney(priceCents)) + '</span>',
      '    </div>',
      '  </div>',
      '  ' + (isOnSale ? '<span class="saved-lists-item-product-badge product__badge product__badge--sale">Sale</span>' : ''),
      '</div>'
    ].join('');
  }

  function updateRenderedActiveListSavingsMeta() {
    if (!state.page || !state.page.itemsBody || !state.activeList) return;

    Array.prototype.forEach.call(
      state.page.itemsBody.querySelectorAll('[data-saved-lists-item-row]'),
      function (row) {
        var variantId = row ? String(row.getAttribute('data-variant-id') || '') : '';
        if (!variantId) return;

        var item = (state.activeList.items || []).find(function (entry) {
          return String(entry.variantId || '') === variantId;
        });
        if (!item) return;

        var savingsContainer = row.querySelector('[data-saved-lists-item-savings]');
        if (!savingsContainer) return;
        savingsContainer.innerHTML = buildListItemSavingsMeta(item);
      }
    );
  }

  async function refreshActiveListLiveSavings() {
    var activeList = state.activeList;
    if (!activeList || !Array.isArray(activeList.items) || !activeList.items.length) {
      updateEstimatedSavingsSummary();
      return;
    }

    var nonce = ++state.activeListSavingsNonce;
    var items = mapItemsForCart(activeList.items, null, {
      source: 'saved_list',
      listId: activeList.id
    });
    var liveSummary = await evaluateLoyaltyForCartItems(items);

    if (nonce !== state.activeListSavingsNonce) return;
    if (!state.activeList || state.activeList.id !== activeList.id) return;

    var lines = liveSummary && Array.isArray(liveSummary.lines) ? liveSummary.lines : [];
    var lineMap = {};

    lines.forEach(function (line) {
      var index = toInteger(line && line.index, -1);
      if (index < 0) return;
      lineMap[String(index)] = line;
    });

    state.activeList.items.forEach(function (item, index) {
      var line = lineMap[String(index)];
      item.liveSavingsCents = line ? Math.max(0, toInteger(line.lineSavingsAmountCents, 0)) : null;
      item.liveSavingsType = line ? (line.lineSavingsType || '') : '';
      item.liveAppliedDiscountPct = line ? Number(line.appliedDiscountPct || 0) : 0;
      item.liveIneligibleReason = line ? (line.ineligibleReason || '') : '';
    });

    updateRenderedActiveListSavingsMeta();
    updateEstimatedSavingsSummary();
  }

  function renderActiveListItems() {
    var refs = state.page;
    var list = state.activeList;

    if (!refs || !list) return;

    var fullListName = normalizeInlineText(list.name || 'Untitled list') || 'Untitled list';
    refs.activeName.textContent = truncateTitle(fullListName, ACTIVE_TITLE_MAX_LENGTH);
    refs.activeName.setAttribute('title', fullListName);

    refs.itemsBody.innerHTML = (list.items || [])
      .map(function (item) {
        var productUrl = item.productUrl || '#';
        var fullProductTitle = normalizeInlineText(item.productTitle || 'Untitled product') || 'Untitled product';
        var displayProductTitle = truncateTitle(fullProductTitle, PRODUCT_TITLE_MAX_LENGTH);
        var imageHtml = item.imageUrl
          ? '<img src="' + escapeHtml(item.imageUrl) + '" alt="' + escapeHtml(fullProductTitle) + '">'
          : '';
        var priceLine = buildSavedListItemPriceMeta(item);
        var variantLine = item.variantTitle ? '<span class="saved-lists-item-product-meta">' + escapeHtml(item.variantTitle) + '</span>' : '';
        var savingsLine = buildListItemSavingsMeta(item);

        return [
          '<tr data-saved-lists-item-row data-variant-id="' + escapeHtml(item.variantId) + '">',
          '  <td><input type="checkbox" data-saved-lists-item-select aria-label="Select ' + escapeHtml(fullProductTitle) + '"></td>',
          '  <td>',
          '    <div class="saved-lists-item-product">',
          '      ' + imageHtml,
          '      <div>',
          '        <a class="saved-lists-item-product-name" href="' + escapeHtml(productUrl) + '" title="' + escapeHtml(fullProductTitle) + '">' + escapeHtml(displayProductTitle) + '</a>',
          '        ' + variantLine,
          '        ' + priceLine,
          '        <span data-saved-lists-item-savings>' + savingsLine + '</span>',
          '      </div>',
          '    </div>',
          '  </td>',
          '  <td>',
          '    <input class="form-field-input" type="number" min="1" value="' + escapeHtml(String(item.quantity)) + '" data-saved-lists-item-qty>',
          '  </td>',
          '  <td>',
          '    <div class="saved-lists-line-actions">',
          '      <button type="button" class="button-secondary saved-lists-line-actions__add" data-saved-lists-item-action="add" aria-label="Add ' + escapeHtml(fullProductTitle) + ' to cart" title="Add to cart">',
          '        <span class="saved-lists-line-actions__add-icon" aria-hidden="true">',
          '          <span class="saved-lists-line-actions__add-plus">+</span>',
          '          <svg viewBox="0 0 24 24" focusable="false">',
          '            <path d="M2.75 4.75h2.3L7.7 16h9.45l2.1-7.65H6.1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>',
          '            <circle cx="9.7" cy="19" r="1.35" fill="none" stroke="currentColor" stroke-width="1.8"></circle>',
          '            <circle cx="16.7" cy="19" r="1.35" fill="none" stroke="currentColor" stroke-width="1.8"></circle>',
          '          </svg>',
          '        </span>',
          '        <span class="saved-lists-line-actions__add-label">Add to cart</span>',
          '      </button>',
          '      <button type="button" class="button-secondary saved-lists-line-actions__remove" data-saved-lists-item-action="remove" aria-label="Remove ' + escapeHtml(fullProductTitle) + '" title="Remove item">',
          '        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">',
          '          <path d="M3 6h18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>',
          '          <path d="M8 6V4h8v2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>',
          '          <path d="M6 6l1 14h10l1-14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"></path>',
          '          <path d="M10 10v7M14 10v7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>',
          '        </svg>',
          '      </button>',
          '    </div>',
          '  </td>',
          '</tr>'
        ].join('');
      })
      .join('');

    refs.itemsEmpty.hidden = (list.items || []).length > 0;
    refs.selectAll.checked = false;
    updateBulkActionState();
  }

  function showItemView(show) {
    if (!state.page) return;

    state.page.listView.hidden = Boolean(show);
    state.page.itemView.hidden = !show;
    if (show) setListsLoading(false);

    if (!show) {
      state.activeList = null;
      if (state.page.estimatedSavingsSummary) {
        state.page.estimatedSavingsSummary.hidden = true;
      }
      if (state.page.estimatedSavingsSelectedRow) {
        state.page.estimatedSavingsSelectedRow.hidden = true;
      }
    }
  }

  async function renderListsView(force) {
    if (!state.page) return;

    showMessage(state.page.message, '');
    setListsLoading(true);

    try {
      await fetchLists(force);
      renderListCards();
    } catch (error) {
      showMessage(state.page.message, error.message || 'Unable to load saved lists.', 'error');
    } finally {
      setListsLoading(false);
    }
  }

  async function openList(listId) {
    if (!state.page) return;

    try {
      showMessage(state.page.message, '');
      showItemView(true);
      setRegionBusy(state.page.itemView, true);
      setRegionBusy(state.page.itemsTable, true);
      setTableLoadingRow(
        state.page.itemsBody,
        4,
        'saved-lists-items-table__loading-row',
        'Loading list items...'
      );
      if (state.page.itemsEmpty) {
        state.page.itemsEmpty.hidden = true;
      }
      await nextFrame();
      state.activeList = await fetchList(listId);
      renderActiveListItems();
      refreshActiveListLiveSavings().catch(function () {});
    } catch (error) {
      showItemView(false);
      showMessage(state.page.message, error.message || 'Unable to load the selected list.', 'error');
    } finally {
      setRegionBusy(state.page.itemView, false);
      setRegionBusy(state.page.itemsTable, false);
    }
  }

  function selectedVariantIdsFromRows() {
    if (!state.page) return [];

    return Array.prototype.slice
      .call(state.page.itemsBody.querySelectorAll('[data-saved-lists-item-select]:checked'))
      .map(function (checkbox) {
        var row = checkbox.closest('[data-saved-lists-item-row]');
        return row ? row.getAttribute('data-variant-id') : '';
      })
      .filter(Boolean);
  }

  async function addCurrentListToCart(selectedIds) {
    if (!state.activeList) return;

    var items = mapItemsForCart(state.activeList.items || [], selectedIds, {
      source: 'saved_list',
      listId: state.activeList.id
    });

    if (!items.length) {
      showToast('No items selected.', 'error');
      return;
    }

    var addResult = await addItemsToCart(items);
    showToast(buildLoyaltyAddToCartMessage('Items added to cart.', addResult && addResult.loyaltyPreview), 'success');
  }

  async function removeItemsFromCurrentList(variantIds) {
    if (!state.activeList || !variantIds.length) return;

    var listId = state.activeList.id;

    await Promise.all(
      variantIds.map(function (variantId) {
        return deleteListItem(listId, variantId);
      })
    );

    state.activeList.items = (state.activeList.items || []).filter(function (item) {
      return variantIds.indexOf(String(item.variantId)) === -1;
    });
    state.activeList.itemCount = state.activeList.items.length;

    var listIndex = state.lists.findIndex(function (list) {
      return list.id === state.activeList.id;
    });

    if (listIndex !== -1) {
      state.lists[listIndex].itemCount = state.activeList.itemCount;
    }

    renderActiveListItems();
    renderListCards();
    refreshActiveListLiveSavings().catch(function () {});
  }

  function findActiveItem(variantId) {
    if (!state.activeList) return null;

    return (state.activeList.items || []).find(function (item) {
      return String(item.variantId) === String(variantId);
    }) || null;
  }

  async function renameListWithPrompt(listId, currentName) {
    var existingName = sanitizeListName(currentName || '');
    var chosenName = await requestRenameListName(existingName);
    if (!chosenName) return false;

    var nextName = sanitizeListName(chosenName);
    if (!nextName || nextName === existingName) return false;

    await updateListName(listId, nextName);
    renderListCards();

    if (state.activeList && state.activeList.id === String(listId)) {
      state.activeList.name = nextName;
      renderActiveListItems();
    }

    return true;
  }

  async function handleListGridClick(event) {
    var card = event.target.closest('[data-saved-list-id]');
    if (!card) return;

    var listId = card.getAttribute('data-saved-list-id');
    var actionButton = event.target.closest('[data-saved-list-action]');
    if (!actionButton) {
      await openList(listId);
      return;
    }

    var action = actionButton.getAttribute('data-saved-list-action');
    var rowButtons = card.querySelectorAll('[data-saved-list-action]');
    var list = state.lists.find(function (entry) {
      return entry.id === String(listId);
    }) || null;

    if (action === 'add-to-cart') {
      var stopAddToCartLoading = beginButtonLoading(actionButton, 'Adding...');
      try {
        rowButtons.forEach(function (button) {
          if (button !== actionButton) button.disabled = true;
        });
        var selectedList = await fetchList(listId);
        var addResult = await addItemsToCart(mapItemsForCart(selectedList.items || [], null, {
          source: 'saved_list',
          listId: listId
        }));
        showToast(buildLoyaltyAddToCartMessage('List added to cart.', addResult && addResult.loyaltyPreview), 'success');
      } catch (error) {
        showToast(error.message || 'Unable to add list to cart.', 'error');
      } finally {
        stopAddToCartLoading();
        rowButtons.forEach(function (button) {
          if (button !== actionButton) button.disabled = false;
        });
      }
      return;
    }

    if (action === 'delete') {
      var stopDeleteLoading = beginButtonLoading(actionButton, 'Deleting...');
      try {
        rowButtons.forEach(function (button) {
          if (button !== actionButton) button.disabled = true;
        });
        await deleteList(listId);
        renderListCards();
        showToast('List deleted.', 'success');
      } catch (error) {
        showToast(error.message || 'Unable to delete list.', 'error');
      } finally {
        stopDeleteLoading();
        rowButtons.forEach(function (button) {
          if (button !== actionButton) button.disabled = false;
        });
      }
    }
  }

  async function handleItemsClick(event) {
    if (!state.activeList) return;

    var actionButton = event.target.closest('[data-saved-lists-item-action]');
    if (actionButton) {
      var row = actionButton.closest('[data-saved-lists-item-row]');
      var variantId = row ? row.getAttribute('data-variant-id') : '';
      var action = actionButton.getAttribute('data-saved-lists-item-action');
      var loadingLabel = action === 'remove' ? 'Removing...' : 'Adding...';
      var stopItemActionLoading = beginButtonLoading(actionButton, loadingLabel);

      if (!variantId) {
        stopItemActionLoading();
        return;
      }

      try {
        if (action === 'add') {
          var item = findActiveItem(variantId);
          if (!item) return;
          var addResult = await addItemsToCart([{
            id: item.variantId,
            quantity: item.quantity,
            price: item.price,
            compare_at_price: item.compareAtPrice,
            properties: buildLoyaltyCartProperties({
              source: 'saved_list',
              listId: state.activeList.id
            })
          }]);
          showToast(buildLoyaltyAddToCartMessage('Item added to cart.', addResult && addResult.loyaltyPreview), 'success');
        }

        if (action === 'remove') {
          await removeItemsFromCurrentList([variantId]);
          showToast('Item removed.', 'success');
        }
      } catch (error) {
        showToast(error.message || 'Unable to process request.', 'error');
      } finally {
        stopItemActionLoading();
      }

      return;
    }

    var addListButton = event.target.closest('[data-saved-lists-add-list-to-cart]');
    if (addListButton) {
      var stopAddListLoading = beginButtonLoading(addListButton, 'Adding...');
      try {
        await addCurrentListToCart();
      } catch (error) {
        showToast(error.message || 'Unable to add list to cart.', 'error');
      } finally {
        stopAddListLoading();
      }

      return;
    }

    var addSelectedButton = event.target.closest('[data-saved-lists-add-selected-to-cart]');
    if (addSelectedButton) {
      var stopAddSelectedLoading = beginButtonLoading(addSelectedButton, 'Adding...');
      try {
        await addCurrentListToCart(selectedVariantIdsFromRows());
      } catch (error) {
        showToast(error.message || 'Unable to add selected items to cart.', 'error');
      } finally {
        stopAddSelectedLoading();
      }

      return;
    }

    if (event.target.closest('[data-saved-lists-rename-list]')) {
      var renameButton = state.page && state.page.renameListButton ? state.page.renameListButton : null;
      var stopRenameLoading = beginButtonLoading(renameButton, 'Saving...');

      try {
        var renamed = await renameListWithPrompt(state.activeList.id, state.activeList.name);
        if (renamed) {
          showToast('List name updated.', 'success');
        }
      } catch (error) {
        showToast(error.message || 'Unable to rename list.', 'error');
      } finally {
        stopRenameLoading();
      }
    }
  }

  async function handleItemsChange(event) {
    if (!state.activeList) return;

    var target = event.target;

    if (target.matches('[data-saved-lists-select-all]')) {
      var shouldCheck = target.checked;
      Array.prototype.forEach.call(
        state.page.itemsBody.querySelectorAll('[data-saved-lists-item-select]'),
        function (checkbox) {
          checkbox.checked = shouldCheck;
        }
      );
      updateBulkActionState();
      return;
    }

    if (target.matches('[data-saved-lists-item-select]')) {
      updateBulkActionState();
      return;
    }

    if (target.matches('[data-saved-lists-item-qty]')) {
      var row = target.closest('[data-saved-lists-item-row]');
      var variantId = row ? row.getAttribute('data-variant-id') : '';
      var rowActionButtons = row ? row.querySelectorAll('[data-saved-lists-item-action]') : [];
      var quantity = toInteger(target.value, 1);

      if (!variantId || quantity < 1) {
        target.value = '1';
        quantity = 1;
      }

      var item = findActiveItem(variantId);
      if (!item) return;

      target.disabled = true;
      setRegionBusy(row, true);
      Array.prototype.forEach.call(rowActionButtons, function (button) {
        button.disabled = true;
      });

      try {
        await updateListItem(state.activeList.id, variantId, quantity);
        item.quantity = quantity;
        target.value = String(quantity);
        state.productPreviewCache = {};

        var savingsContainer = row ? row.querySelector('[data-saved-lists-item-savings]') : null;
        if (savingsContainer) {
          savingsContainer.innerHTML = buildListItemSavingsMeta(item);
        }
        updateEstimatedSavingsSummary();
        refreshActiveListLiveSavings().catch(function () {});
        showToast('Quantity updated.', 'success');
      } catch (error) {
        target.value = String(item.quantity);
        showToast(error.message || 'Unable to update quantity.', 'error');
      } finally {
        target.disabled = false;
        setRegionBusy(row, false);
        Array.prototype.forEach.call(rowActionButtons, function (button) {
          button.disabled = false;
        });
      }
    }
  }

  function syncCreateFormButtonState() {
    if (!state.page || !state.page.createForm) return;

    var input = state.page.createForm.querySelector('input[name="name"]');
    var submitButton = state.page.createForm.querySelector('button[type="submit"]');
    if (!input || !submitButton) return;

    if (input.disabled) return;
    submitButton.disabled = String(input.value || '').trim().length < 1;
  }

  async function handleCreateFormSubmit(event) {
    event.preventDefault();

    if (!state.page) return;

    var input = state.page.createForm.querySelector('input[name="name"]');
    var listName = sanitizeListName(input && input.value ? input.value : '');
    if (input) input.value = listName;

    if (!listName) {
      syncCreateFormButtonState();
      return;
    }

    var submitButton = state.page.createForm.querySelector('button[type="submit"]');
    var stopCreateListLoading = beginButtonLoading(submitButton, 'Creating...');

    try {
      if (input) input.disabled = true;
      await createList(listName);
      await renderListsView(true);
      input.value = '';
      showMessage(state.page.message, 'List created.', 'success');
    } catch (error) {
      showMessage(state.page.message, error.message || 'Unable to create list.', 'error');
    } finally {
      if (input) input.disabled = false;
      stopCreateListLoading();
      syncCreateFormButtonState();
    }
  }

  function initSavedListsPage() {
    var root = document.querySelector('[data-saved-lists-page]');
    if (!root) return;
    if (!isCustomerLoggedIn) return;

    var loginState = root.querySelector('[data-saved-lists-login-state]');
    var layout = root.querySelector('[data-saved-lists-layout]');
    if (loginState) loginState.hidden = true;
    if (layout) layout.hidden = false;

    state.page = getPageRefs(root);

    if (!state.page.listGrid || !state.page.createForm) return;

    state.page.createForm.addEventListener('submit', handleCreateFormSubmit);
    var createNameInput = state.page.createForm.querySelector('input[name="name"]');
    if (createNameInput) {
      createNameInput.addEventListener('input', syncCreateFormButtonState);
      createNameInput.addEventListener('change', syncCreateFormButtonState);
    }
    if (state.page.filterInput) {
      state.page.filterInput.addEventListener('input', function () {
        renderListCards();
      });
    }

    state.page.listGrid.addEventListener('click', function (event) {
      handleListGridClick(event);
    });
    state.page.listGrid.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      var card = event.target.closest('[data-saved-list-id]');
      if (!card) return;
      if (event.target.closest('button, a, input, select, textarea')) return;

      event.preventDefault();
      openList(card.getAttribute('data-saved-list-id'));
    });

    state.page.backButton.addEventListener('click', function () {
      showItemView(false);
      renderListsView(false);
    });

    state.page.itemView.addEventListener('click', function (event) {
      handleItemsClick(event);
    });

    state.page.itemView.addEventListener('change', function (event) {
      handleItemsChange(event);
    });

    showItemView(false);
    syncCreateFormButtonState();
    renderListsView(true);
  }

  function normalizeOrderLineItem(rawItem) {
    var item = rawItem || {};
    var variantTitle = item.variantTitle || item.variant_title || '';
    var lineSavingsAmount = readMoneyValue([
      item.lineSavingsAmount,
      item.line_savings_amount,
      item.line_savings_amount_cents,
      item.savingsAmount,
      item.savings_amount_cents
    ], 0);
    var appliedDiscountPct = readMoneyValue([
      item.appliedDiscountPct,
      item.applied_discount_pct
    ], 0);
    if (variantTitle === 'Default Title') variantTitle = '';
    if (!Number.isFinite(lineSavingsAmount) || lineSavingsAmount < 0) lineSavingsAmount = 0;
    if (!Number.isFinite(appliedDiscountPct) || appliedDiscountPct < 0) appliedDiscountPct = 0;

    return {
      lineId: String(item.lineId || item.line_id || item.id || ''),
      variantId: item.variantId || item.variant_id || '',
      productTitle: normalizeInlineText(item.productTitle || item.product_title || item.title || 'Untitled product') || 'Untitled product',
      productUrl: item.productUrl || item.product_url || item.url || '',
      variantTitle: variantTitle,
      quantity: Math.max(1, toInteger(item.quantity, 1)),
      price: Number(item.price || 0),
      lineTotal: Number(item.lineTotal || item.line_total || 0),
      imageUrl: item.imageUrl || item.image_url || item.image || '',
      lineSavingsAmount: lineSavingsAmount,
      lineSavingsType: item.lineSavingsType || item.line_savings_type || '',
      appliedDiscountPct: appliedDiscountPct
    };
  }

  function normalizeOrder(rawOrder) {
    var order = rawOrder || {};
    var taxesIncluded = Boolean(order.taxesIncluded || order.taxes_included);
    var lineItems = Array.isArray(order.lineItems || order.line_items)
      ? (order.lineItems || order.line_items).map(normalizeOrderLineItem)
      : [];
    var fallbackItemCount = lineItems.reduce(function (total, item) {
      return total + Math.max(0, toInteger(item.quantity, 0));
    }, 0);
    var lineItemsSubtotal = lineItems.reduce(function (total, item) {
      return total + Number(item.lineTotal || 0);
    }, 0);
    var subtotalPrice = readMoneyValue([
      order.subtotalPrice,
      order.subtotal_price
    ], lineItemsSubtotal);
    var discountTotal = readMoneyValue([
      order.discountTotal,
      order.discount_total,
      order.totalDiscounts,
      order.total_discounts
    ], 0);
    var shippingPrice = readMoneyValue([
      order.shippingPrice,
      order.shipping_price
    ], null);
    var taxPrice = readMoneyValue([
      order.taxPrice,
      order.tax_price
    ], null);
    var totalPrice = readMoneyValue([
      order.totalPrice,
      order.total_price
    ], null);
    var orderTotalSavings = readMoneyValue([
      order.orderTotalSavings,
      order.order_total_savings,
      order.order_total_savings_cents,
      order.totalSavings,
      order.total_savings_cents
    ], null);
    var orderFirstListSavings = readMoneyValue([
      order.orderFirstListSavings,
      order.order_first_list_savings,
      order.order_first_list_savings_cents,
      order.firstListSavings,
      order.first_list_savings_cents
    ], 0);
    var orderReorderSavings = readMoneyValue([
      order.orderReorderSavings,
      order.order_reorder_savings,
      order.order_reorder_savings_cents,
      order.reorderSavings,
      order.reorder_savings_cents
    ], 0);

    if (discountTotal === null || discountTotal < 0) discountTotal = 0;
    if (subtotalPrice === null) subtotalPrice = lineItemsSubtotal;
    if (orderFirstListSavings === null || orderFirstListSavings < 0) orderFirstListSavings = 0;
    if (orderReorderSavings === null || orderReorderSavings < 0) orderReorderSavings = 0;
    if (orderTotalSavings === null || orderTotalSavings < 0) {
      orderTotalSavings = Math.max(0, orderFirstListSavings + orderReorderSavings);
    }
    if (totalPrice === null) {
      var computedTotal = subtotalPrice - discountTotal + (shippingPrice || 0);
      if (!taxesIncluded) computedTotal += (taxPrice || 0);
      totalPrice = Math.max(0, computedTotal);
    }

    return {
      id: String(order.id || order.orderNumber || order.order_number || ''),
      name: normalizeInlineText(order.name || ('Order #' + String(order.orderNumber || order.order_number || ''))) || 'Order',
      orderNumber: order.orderNumber || order.order_number || '',
      customerUrl: order.customerUrl || order.customer_url || '',
      createdAt: order.createdAt || order.created_at || '',
      taxesIncluded: taxesIncluded,
      subtotalPrice: subtotalPrice,
      discountTotal: discountTotal,
      shippingPrice: shippingPrice,
      taxPrice: taxPrice,
      totalPrice: totalPrice,
      orderTotalSavings: orderTotalSavings,
      orderFirstListSavings: orderFirstListSavings,
      orderReorderSavings: orderReorderSavings,
      itemCount: Math.max(0, toInteger(order.itemCount || order.item_count, fallbackItemCount)),
      lineItems: lineItems
    };
  }

  function getLineSavingsTypeLabel(value) {
    var normalized = normalizeInlineText(value || '').toLowerCase();
    if (!normalized) return '';
    if (normalized === 'first_list_10') return 'First-list reward';
    if (normalized === 'reorder_tier') return 'Loyalty re-order';
    return '';
  }

  function getOrdersPageRefs(root) {
    return {
      root: root,
      layout: root.querySelector('[data-orders-layout]'),
      loginState: root.querySelector('[data-orders-login-state]'),
      listView: root.querySelector('[data-orders-list-view]'),
      itemView: root.querySelector('[data-orders-item-view]'),
      message: root.querySelector('[data-orders-message]'),
      loading: root.querySelector('[data-orders-loading]'),
      loadingText: root.querySelector('[data-orders-loading-text]'),
      empty: root.querySelector('[data-orders-empty]'),
      listGrid: root.querySelector('[data-orders-list-grid]'),
      backButton: root.querySelector('[data-orders-back]'),
      activeName: root.querySelector('[data-orders-active-name]'),
      itemsTable: root.querySelector('.saved-orders-items-table'),
      itemsBody: root.querySelector('[data-orders-items-body]'),
      itemsEmpty: root.querySelector('[data-orders-items-empty]'),
      summary: root.querySelector('[data-orders-summary]'),
      summarySubtotal: root.querySelector('[data-orders-summary-subtotal]'),
      summaryDiscountRow: root.querySelector('[data-orders-summary-discount-row]'),
      summaryDiscount: root.querySelector('[data-orders-summary-discount]'),
      summaryShippingRow: root.querySelector('[data-orders-summary-shipping-row]'),
      summaryShipping: root.querySelector('[data-orders-summary-shipping]'),
      summaryTaxRow: root.querySelector('[data-orders-summary-tax-row]'),
      summaryTax: root.querySelector('[data-orders-summary-tax]'),
      summarySavingsRow: root.querySelector('[data-orders-summary-savings-row]'),
      summarySavings: root.querySelector('[data-orders-summary-savings]'),
      summaryFirstListRow: root.querySelector('[data-orders-summary-first-list-row]'),
      summaryFirstList: root.querySelector('[data-orders-summary-first-list]'),
      summaryReorderRow: root.querySelector('[data-orders-summary-reorder-row]'),
      summaryReorder: root.querySelector('[data-orders-summary-reorder]'),
      summaryIncludedTaxRow: root.querySelector('[data-orders-summary-included-tax-row]'),
      summaryIncludedTax: root.querySelector('[data-orders-summary-included-tax]'),
      summaryTotal: root.querySelector('[data-orders-summary-total]'),
      reorderButton: root.querySelector('[data-orders-reorder]'),
      createListButton: root.querySelector('[data-orders-create-list]')
    };
  }

  function getOrdersFromPage(root) {
    var source = root.querySelector('[data-orders-source]');
    if (!source) return [];

    try {
      var payload = JSON.parse(source.textContent || '{}');
      var rawOrders = Array.isArray(payload.orders) ? payload.orders : [];
      return rawOrders.map(normalizeOrder).filter(function (order) {
        return order.id;
      });
    } catch (error) {
      console.warn('saved-lists: invalid orders payload', error);
      return [];
    }
  }

  function getOrderById(orderId) {
    return state.orders.find(function (order) {
      return order.id === String(orderId);
    }) || null;
  }

  function buildOrderCartItems(order) {
    var lineItems = (order && order.lineItems) || [];
    var quantitiesByVariantId = {};
    var orderId = order && order.id ? String(order.id) : '';

    lineItems.forEach(function (lineItem) {
      var variantId = String(lineItem.variantId || '').trim();
      if (!variantId) return;
      quantitiesByVariantId[variantId] = (quantitiesByVariantId[variantId] || 0) + Math.max(1, toInteger(lineItem.quantity, 1));
    });

    return Object.keys(quantitiesByVariantId).map(function (variantId) {
      var item = {
        id: variantId,
        quantity: quantitiesByVariantId[variantId]
      };

      var properties = buildLoyaltyCartProperties({
        source: 'orders_reorder',
        orderId: orderId
      });

      if (properties) {
        item.properties = properties;
      }

      return item;
    });
  }

  function renderOrdersList() {
    var refs = state.ordersPage;
    if (!refs) return;

    refs.listGrid.innerHTML = state.orders
      .map(function (order) {
        var fullOrderName = normalizeInlineText(order.name || '') || ('Order #' + String(order.orderNumber || ''));
        var displayOrderName = truncateTitle(fullOrderName, CARD_TITLE_MAX_LENGTH);
        var formattedTotal = formatMoney(order.totalPrice);
        var dateMeta = order.createdAt ? '<p class="saved-orders-list-card__date">' + escapeHtml(order.createdAt) + '</p>' : '';

        return [
          '<article class="saved-orders-list-card saved-orders-list-card--clickable" data-order-id="' + escapeHtml(order.id) + '" tabindex="0" role="button" aria-label="Open order ' + escapeHtml(fullOrderName) + '">',
          '  <div class="saved-orders-list-card__summary">',
          '    <h3 title="' + escapeHtml(fullOrderName) + '">' + escapeHtml(displayOrderName) + '</h3>',
          '    <div class="saved-orders-list-card__meta-row">',
          '      <div class="saved-orders-list-card__meta-left">',
          '        <span class="saved-orders-list-card__meta-item">Qty: ' + escapeHtml(String(order.itemCount)) + '</span>',
          '      </div>',
          '      <span class="saved-orders-list-card__total">Total: ' + escapeHtml(formattedTotal) + '</span>',
          '    </div>',
          '    ' + dateMeta,
          '  </div>',
          '  <div class="saved-orders-list-card__actions">',
          '    <button type="button" class="button-secondary" data-orders-action="create-list">Create list from order</button>',
          '    <button type="button" class="button-secondary" data-orders-action="reorder">Order again</button>',
          '  </div>',
          '</article>'
        ].join('');
      })
      .join('');

    refs.empty.hidden = state.orders.length > 0;
  }

  function renderActiveOrder() {
    var refs = state.ordersPage;
    var order = state.activeOrder;
    if (!refs || !order) return;

    var title = normalizeInlineText(order.name || '') || ('Order #' + String(order.orderNumber || ''));
    if (order.createdAt) {
      title += ' \u2022 ' + order.createdAt;
    }
    refs.activeName.textContent = truncateTitle(title, ACTIVE_TITLE_MAX_LENGTH);
    refs.activeName.setAttribute('title', title);

    refs.itemsBody.innerHTML = (order.lineItems || [])
      .map(function (lineItem) {
        var productUrl = lineItem.productUrl || '#';
        var fullProductTitle = normalizeInlineText(lineItem.productTitle || 'Untitled product') || 'Untitled product';
        var displayProductTitle = truncateTitle(fullProductTitle, PRODUCT_TITLE_MAX_LENGTH);
        var imageHtml = lineItem.imageUrl
          ? '<img src="' + escapeHtml(lineItem.imageUrl) + '" alt="' + escapeHtml(fullProductTitle) + '">'
          : '';
        var variantMeta = lineItem.variantTitle ? '<span class="saved-orders-item-product-meta">' + escapeHtml(lineItem.variantTitle) + '</span>' : '';

        return [
          '<tr>',
          '  <td>',
          '    <div class="saved-orders-item-product">',
          '      ' + imageHtml,
          '      <div>',
          '        <a class="saved-orders-item-product-name" href="' + escapeHtml(productUrl) + '" title="' + escapeHtml(fullProductTitle) + '">' + escapeHtml(displayProductTitle) + '</a>',
          '        ' + variantMeta,
          '      </div>',
          '    </div>',
          '  </td>',
          '  <td>' + escapeHtml(String(lineItem.quantity)) + '</td>',
          '  <td>' + escapeHtml(formatMoney(lineItem.price)) + '</td>',
          '  <td class="saved-orders-item-total">' + escapeHtml(formatMoney(lineItem.lineTotal)) + '</td>',
          '</tr>'
        ].join('');
      })
      .join('');

    refs.itemsEmpty.hidden = (order.lineItems || []).length > 0;

    if (refs.summary) {
      var hasShipping = order.shippingPrice !== null && typeof order.shippingPrice !== 'undefined';
      var hasTax = Number(order.taxPrice || 0) > 0;
      var useIncludedTaxRow = hasTax && Boolean(order.taxesIncluded);
      var useAdditiveTaxRow = hasTax && !Boolean(order.taxesIncluded);

      refs.summary.hidden = false;

      if (refs.summarySubtotal) refs.summarySubtotal.textContent = formatMoney(order.subtotalPrice);

      if (refs.summaryShippingRow) refs.summaryShippingRow.hidden = !hasShipping;
      if (hasShipping && refs.summaryShipping) refs.summaryShipping.textContent = formatMoney(order.shippingPrice);

      if (refs.summaryTaxRow) refs.summaryTaxRow.hidden = !useAdditiveTaxRow;
      if (useAdditiveTaxRow && refs.summaryTax) refs.summaryTax.textContent = formatMoney(order.taxPrice);

      if (refs.summaryTotal) refs.summaryTotal.textContent = formatMoney(order.totalPrice);

      if (refs.summaryIncludedTaxRow) refs.summaryIncludedTaxRow.hidden = !useIncludedTaxRow;
      if (useIncludedTaxRow && refs.summaryIncludedTax) refs.summaryIncludedTax.textContent = formatMoney(order.taxPrice);
    }
  }

  function showOrdersItemView(show) {
    if (!state.ordersPage) return;

    state.ordersPage.listView.hidden = Boolean(show);
    state.ordersPage.itemView.hidden = !show;

    if (!show) {
      state.activeOrder = null;
      if (state.ordersPage.summary) state.ordersPage.summary.hidden = true;
    }
  }

  function setOrdersLoading(isLoading, message) {
    if (!state.ordersPage) return;

    if (state.ordersPage.loadingText && message) {
      state.ordersPage.loadingText.textContent = message;
    }

    if (state.ordersPage.loading) {
      state.ordersPage.loading.hidden = !Boolean(isLoading);
    }

    setRegionBusy(state.ordersPage.itemView, Boolean(isLoading));
    setRegionBusy(state.ordersPage.itemsTable, Boolean(isLoading));
  }

  async function reorderActiveOrder(order) {
    var cartItems = buildOrderCartItems(order);
    if (!cartItems.length) {
      throw new Error('No purchasable items found in this order.');
    }

    return addItemsToCart(cartItems);
  }

  async function createSavedListFromOrder(order) {
    var listItems = buildOrderCartItems(order);
    if (!listItems.length) {
      throw new Error('No purchasable items found in this order.');
    }

    var defaultName = 'Order ' + String(order.name || order.orderNumber || '').replace(/^#/, '');
    var listName = await requestOrderListName(defaultName);
    if (!listName) return false;

    var createdList = await createList(listName);

    await Promise.all(
      listItems.map(function (item) {
        return addItemToList(createdList.id, item.id, item.quantity);
      })
    );

    await fetchLists(true);
    return true;
  }

  async function openOrder(orderId) {
    var order = getOrderById(orderId);
    if (!order) return;

    try {
      state.activeOrder = order;
      showOrdersItemView(true);
      setOrdersLoading(true, 'Loading order details...');
      setTableLoadingRow(
        state.ordersPage && state.ordersPage.itemsBody,
        4,
        'saved-orders-items-table__loading-row',
        'Loading order details...'
      );
      if (state.ordersPage && state.ordersPage.itemsEmpty) {
        state.ordersPage.itemsEmpty.hidden = true;
      }
      if (state.ordersPage && state.ordersPage.summary) {
        state.ordersPage.summary.hidden = true;
      }
      await nextFrame();
      renderActiveOrder();
    } catch (error) {
      showToast(error.message || 'Unable to load order details.', 'error');
    } finally {
      setOrdersLoading(false);
    }
  }

  function setOrdersButtonsDisabled(disabled) {
    if (!state.ordersPage) return;

    if (state.ordersPage.reorderButton) {
      state.ordersPage.reorderButton.disabled = disabled;
    }

    if (state.ordersPage.createListButton) {
      state.ordersPage.createListButton.disabled = disabled;
    }
  }

  function initOrdersPage() {
    var root = document.querySelector('[data-orders-page]');
    if (!root) return;

    state.ordersPage = getOrdersPageRefs(root);
    if (!state.ordersPage.listGrid || !state.ordersPage.itemsBody) return;

    var orders = getOrdersFromPage(root);

    if (!orders.length && !isCustomerLoggedIn) return;

    state.orders = orders;

    if (state.ordersPage.loginState) state.ordersPage.loginState.hidden = true;
    if (state.ordersPage.layout) state.ordersPage.layout.hidden = false;

    renderOrdersList();
    showOrdersItemView(false);

    state.ordersPage.listGrid.addEventListener('click', function (event) {
      var card = event.target.closest('[data-order-id]');
      if (!card) return;

      var orderId = card.getAttribute('data-order-id');
      var actionButton = event.target.closest('[data-orders-action]');
      if (!actionButton) {
        openOrder(orderId);
        return;
      }

      var action = actionButton.getAttribute('data-orders-action');
      var order = getOrderById(orderId);
      if (!order) return;
      var loadingLabel = action === 'reorder' ? 'Adding...' : 'Creating...';
      var stopOrderActionLoading = beginButtonLoading(actionButton, loadingLabel);

      var rowButtons = card.querySelectorAll('[data-orders-action]');
      rowButtons.forEach(function (button) {
        if (button !== actionButton) button.disabled = true;
      });

      (async function () {
        try {
          if (action === 'reorder') {
            var reorderResult = await reorderActiveOrder(order);
            showToast(buildLoyaltyAddToCartMessage('Order items added to cart.', reorderResult && reorderResult.loyaltyPreview), 'success');
          } else if (action === 'create-list') {
            var listCreated = await createSavedListFromOrder(order);
            if (listCreated) {
              showToast('Saved list created from order.', 'success');
            }
          }
        } catch (error) {
          if (action === 'reorder') {
            showToast(error.message || 'Unable to add order to cart.', 'error');
          } else if (action === 'create-list') {
            showToast(error.message || 'Unable to create list from order.', 'error');
          }
        } finally {
          stopOrderActionLoading();
          rowButtons.forEach(function (button) {
            if (button !== actionButton) button.disabled = false;
          });
        }
      })();
    });
    state.ordersPage.listGrid.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      var card = event.target.closest('[data-order-id]');
      if (!card) return;
      if (event.target.closest('button, a, input, select, textarea')) return;

      event.preventDefault();
      openOrder(card.getAttribute('data-order-id'));
    });

    if (state.ordersPage.backButton) {
      state.ordersPage.backButton.addEventListener('click', function () {
        showOrdersItemView(false);
      });
    }

    state.ordersPage.itemView.addEventListener('click', async function (event) {
      if (!state.activeOrder) return;

      var reorderButton = event.target.closest('[data-orders-reorder]');
      if (reorderButton) {
        var stopReorderLoading = beginButtonLoading(reorderButton, 'Adding...');
        try {
          setOrdersButtonsDisabled(true);
          var reorderResult = await reorderActiveOrder(state.activeOrder);
          showToast(buildLoyaltyAddToCartMessage('Order items added to cart.', reorderResult && reorderResult.loyaltyPreview), 'success');
        } catch (error) {
          showToast(error.message || 'Unable to add order to cart.', 'error');
        } finally {
          setOrdersButtonsDisabled(false);
          stopReorderLoading();
        }
      }

      var createListButton = event.target.closest('[data-orders-create-list]');
      if (createListButton) {
        var stopCreateFromOrderLoading = beginButtonLoading(createListButton, 'Creating...');
        try {
          setOrdersButtonsDisabled(true);
          var listCreated = await createSavedListFromOrder(state.activeOrder);
          if (listCreated) {
            showToast('Saved list created from order.', 'success');
          }
        } catch (error) {
          showToast(error.message || 'Unable to create list from order.', 'error');
        } finally {
          setOrdersButtonsDisabled(false);
          stopCreateFromOrderLoading();
        }
      }
    });
  }

  function normalizeLoyaltyApplySummary(payload) {
    var source = payload && typeof payload === 'object' ? payload : {};
    var applyPlan = source.apply_plan && typeof source.apply_plan === 'object'
      ? source.apply_plan
      : (source.applyPlan && typeof source.applyPlan === 'object' ? source.applyPlan : source);
    var totals = applyPlan.totals && typeof applyPlan.totals === 'object'
      ? applyPlan.totals
      : (source.totals && typeof source.totals === 'object' ? source.totals : {});
    var savingsCents = readMoneyValue([
      totals.loyalty_savings_total_cents,
      totals.loyaltySavingsTotalCents,
      source.loyalty_savings_total_cents,
      source.loyaltySavingsTotalCents
    ], 0);
    var subtotalBeforeCents = readMoneyValue([
      totals.cart_subtotal_before_discount_cents,
      totals.cartSubtotalBeforeDiscountCents
    ], null);
    var subtotalAfterCents = readMoneyValue([
      totals.cart_subtotal_after_discount_cents,
      totals.cartSubtotalAfterDiscountCents
    ], null);
    var checkoutPayload = applyPlan.checkout_payload && typeof applyPlan.checkout_payload === 'object'
      ? applyPlan.checkout_payload
      : (applyPlan.checkoutPayload && typeof applyPlan.checkoutPayload === 'object'
        ? applyPlan.checkoutPayload
        : (source.checkout_payload && typeof source.checkout_payload === 'object'
          ? source.checkout_payload
          : (source.checkoutPayload && typeof source.checkoutPayload === 'object' ? source.checkoutPayload : {})));

    if (!Number.isFinite(savingsCents) || savingsCents < 0) savingsCents = 0;
    if (!Number.isFinite(subtotalBeforeCents) || subtotalBeforeCents < 0) subtotalBeforeCents = null;
    if (!Number.isFinite(subtotalAfterCents) || subtotalAfterCents < 0) subtotalAfterCents = null;

    return {
      savingsCents: Math.max(0, Math.round(savingsCents)),
      subtotalBeforeCents: subtotalBeforeCents === null ? null : Math.max(0, Math.round(subtotalBeforeCents)),
      subtotalAfterCents: subtotalAfterCents === null ? null : Math.max(0, Math.round(subtotalAfterCents)),
      checkoutPayload: checkoutPayload
    };
  }

  function buildLoyaltyApplyLinesFromCart(cart) {
    var cartObject = cart && typeof cart === 'object' ? cart : {};
    var cartItems = Array.isArray(cartObject.items) ? cartObject.items : [];

    return cartItems.map(function (item, index) {
      var line = {
        index: index,
        variant_id: String(item && (item.variant_id || item.id || '') || '').trim(),
        quantity: Math.max(1, toInteger(item && item.quantity, 1))
      };
      var unitPriceCents = readMoneyValue([
        item && item.original_price,
        item && item.price
      ], null);

      if (line.variant_id === '') return null;
      if (unitPriceCents !== null) {
        var normalizedPriceCents = Math.max(0, Math.round(unitPriceCents));
        line.price_cents = normalizedPriceCents;
        line.compare_at_price_cents = normalizedPriceCents;
      }

      if (item && item.properties && typeof item.properties === 'object') {
        var properties = {};
        Object.keys(item.properties).forEach(function (key) {
          var value = item.properties[key];
          if (value === null || typeof value === 'undefined') return;
          properties[key] = String(value);
        });
        if (Object.keys(properties).length) {
          line.properties = properties;
        }
      }

      return line;
    }).filter(Boolean);
  }

  function normalizeLoyaltyApplyLines(lines) {
    if (!Array.isArray(lines)) return [];

    return lines.map(function (entry, index) {
      var line = entry && typeof entry === 'object' ? Object.assign({}, entry) : {};
      line.index = toInteger(line.index, index);
      line.variant_id = String(line.variant_id || line.variantId || '').trim();
      line.quantity = Math.max(1, toInteger(line.quantity, 1));

      var priceCents = readMoneyValue([
        line.price_cents,
        line.priceCents,
        line.price
      ], null);
      var compareAtPriceCents = readMoneyValue([
        line.compare_at_price_cents,
        line.compareAtPriceCents,
        line.compare_at_price,
        line.compareAtPrice
      ], null);

      delete line.price;
      delete line.priceCents;
      delete line.compare_at_price;
      delete line.compareAtPrice;

      if (priceCents !== null) {
        line.price_cents = Math.max(0, Math.round(priceCents));
      }
      if (compareAtPriceCents !== null) {
        line.compare_at_price_cents = Math.max(0, Math.round(compareAtPriceCents));
      }

      if (!line.variant_id) return null;
      return line;
    }).filter(Boolean);
  }

  function getStaticCartRoot() {
    var marker = document.querySelector('[data-section-type="static-cart"]');
    if (marker && marker.closest) {
      var sectionRoot = marker.closest('.shopify-section');
      if (sectionRoot) return sectionRoot;
    }

    return document.querySelector('form[aria-label="cart checkout"]') || null;
  }

  async function getCartPayload() {
    var response = await fetch(cartDataUrl(), {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Unable to read cart.');
    }

    return response.json();
  }

  async function evaluateLoyaltyCartApply(lines) {
    if (!Array.isArray(lines) || !lines.length) return null;
    var normalizedLines = normalizeLoyaltyApplyLines(lines);
    if (!normalizedLines.length) return null;

    var payload = await api('/loyalty/cart/apply', {
      method: 'POST',
      body: { lines: normalizedLines }
    });

    return normalizeLoyaltyApplySummary(payload);
  }

  async function evaluateLoyaltyCheckoutApply(lines) {
    if (!Array.isArray(lines) || !lines.length) return null;
    var normalizedLines = normalizeLoyaltyApplyLines(lines);
    if (!normalizedLines.length) return null;

    var payload = await api('/loyalty/checkout/apply', {
      method: 'POST',
      body: { lines: normalizedLines }
    });

    return normalizeLoyaltyApplySummary(payload);
  }

  function ensureCartLoyaltyRows() {
    var finalTotal = document.querySelector('.cart-final-total');
    if (!finalTotal) return null;

    var subtotalRow = finalTotal.querySelector('.cart-subtotal');
    if (!subtotalRow) return null;

    var savingsRow = finalTotal.querySelector('[data-cart-loyalty-savings-row]');
    if (!savingsRow) {
      savingsRow = document.createElement('div');
      savingsRow.className = 'cart-subtotal cart-subtotal--loyalty';
      savingsRow.setAttribute('data-cart-loyalty-savings-row', '');
      savingsRow.hidden = true;
      savingsRow.innerHTML = '<span>Loyalty savings</span><span class="money" data-cart-loyalty-savings></span>';
      finalTotal.insertBefore(savingsRow, subtotalRow);
    }

    var afterRow = finalTotal.querySelector('[data-cart-loyalty-after-row]');
    if (!afterRow) {
      afterRow = document.createElement('div');
      afterRow.className = 'cart-subtotal cart-subtotal--loyalty-after';
      afterRow.setAttribute('data-cart-loyalty-after-row', '');
      afterRow.hidden = true;
      afterRow.innerHTML = '<span>Subtotal after loyalty</span><span class="money" data-cart-loyalty-after></span>';
      finalTotal.insertBefore(afterRow, subtotalRow.nextSibling);
    }

    return {
      savingsRow: savingsRow,
      savingsValue: savingsRow.querySelector('[data-cart-loyalty-savings]'),
      afterRow: afterRow,
      afterValue: afterRow.querySelector('[data-cart-loyalty-after]')
    };
  }

  function removeLegacyCartLoyaltyRows() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-cart-loyalty-savings-row], [data-cart-loyalty-after-row]'),
      function (row) {
        if (row && row.parentNode) {
          row.parentNode.removeChild(row);
        }
      }
    );
  }

  function renderCartLoyaltySummary(summary) {
    // Legacy subtotal rows are retired now that Shopify discount allocations
    // are the single source of truth for loyalty discounts.
    removeLegacyCartLoyaltyRows();
  }

  async function refreshCartLoyaltySummary() {
    if (!isCustomerLoggedIn || !state.loyaltyEvaluateEnabled) return;
    if (!getStaticCartRoot()) return;

    try {
      var cart = await getCartPayload();
      var lines = buildLoyaltyApplyLinesFromCart(cart);
      if (!lines.length) {
        state.cartLoyaltySummary = null;
        renderCartLoyaltySummary(null);
        return;
      }

      var summary = await evaluateLoyaltyCartApply(lines);
      state.cartLoyaltySummary = summary;
      renderCartLoyaltySummary(summary);
    } catch (error) {
      state.cartLoyaltySummary = null;
      renderCartLoyaltySummary(null);
    }
  }

  function setCartAttributeInputs(form, attributes) {
    if (!form) return;
    var values = attributes && typeof attributes === 'object' ? attributes : {};

    Array.prototype.forEach.call(
      form.querySelectorAll('input[data-loyalty-cart-attribute-input="true"]'),
      function (input) {
        input.remove();
      }
    );

    Object.keys(values).forEach(function (key) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[' + key + ']';
      input.value = String(values[key]);
      input.setAttribute('data-loyalty-cart-attribute-input', 'true');
      form.appendChild(input);
    });
  }

  function normalizeNoteAttributes(value) {
    var attributes = {};
    if (!value) return attributes;

    if (Array.isArray(value)) {
      value.forEach(function (entry) {
        if (!entry || typeof entry !== 'object') return;
        var key = normalizeInlineText(entry.key || entry.name || '');
        var rawValue = entry.value;
        if (!key || rawValue === null || typeof rawValue === 'undefined') return;
        attributes[key] = String(rawValue);
      });
      return attributes;
    }

    if (typeof value === 'object') {
      Object.keys(value).forEach(function (key) {
        var rawValue = value[key];
        if (!key || rawValue === null || typeof rawValue === 'undefined') return;
        attributes[key] = String(rawValue);
      });
    }

    return attributes;
  }

  function normalizeLinePropertyPatches(value) {
    var patches = {};
    if (!value) return patches;

    if (Array.isArray(value)) {
      value.forEach(function (entry) {
        if (!entry || typeof entry !== 'object') return;
        var index = toInteger(entry.index, -1);
        if (index < 0) return;
        if (!entry.properties || typeof entry.properties !== 'object') return;
        patches[String(index)] = entry.properties;
      });
      return patches;
    }

    if (typeof value === 'object') {
      return value;
    }

    return patches;
  }

  function hasPropertyPatchChanges(existingProperties, patchProperties) {
    var current = existingProperties && typeof existingProperties === 'object' ? existingProperties : {};
    var patch = patchProperties && typeof patchProperties === 'object' ? patchProperties : {};
    var patchKeys = Object.keys(patch);

    if (!patchKeys.length) return false;

    for (var index = 0; index < patchKeys.length; index += 1) {
      var key = patchKeys[index];
      var nextValue = patch[key];
      if (nextValue === null || typeof nextValue === 'undefined') continue;

      var currentValue = Object.prototype.hasOwnProperty.call(current, key)
        ? String(current[key])
        : '';
      if (currentValue !== String(nextValue)) {
        return true;
      }
    }

    return false;
  }

  function buildCartAttributeUpdates(cart, nextAttributes) {
    var cartObject = cart && typeof cart === 'object' ? cart : {};
    var existing = cartObject.attributes && typeof cartObject.attributes === 'object'
      ? cartObject.attributes
      : {};
    var incoming = nextAttributes && typeof nextAttributes === 'object'
      ? nextAttributes
      : {};
    var updates = {};

    Object.keys(incoming).forEach(function (key) {
      var nextValue = incoming[key];
      if (!key || nextValue === null || typeof nextValue === 'undefined') return;
      var normalizedNext = String(nextValue);
      var currentValue = Object.prototype.hasOwnProperty.call(existing, key)
        ? String(existing[key])
        : '';
      if (currentValue !== normalizedNext) {
        updates[key] = normalizedNext;
      }
    });

    if (!Object.prototype.hasOwnProperty.call(incoming, '_first_list_reward_applied')
      && Object.prototype.hasOwnProperty.call(existing, '_first_list_reward_applied')
      && String(existing._first_list_reward_applied || '') !== '') {
      updates._first_list_reward_applied = '';
    }

    return updates;
  }

  async function applyCartAttributeUpdates(updates) {
    var attributeUpdates = updates && typeof updates === 'object' ? updates : {};
    if (!Object.keys(attributeUpdates).length) return false;

    var response = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: attributeUpdates
      })
    });

    if (!response.ok) {
      throw new Error('Unable to apply loyalty cart attributes.');
    }

    return true;
  }

  function syncCartLineKeysInDom(cart) {
    var cartObject = cart && typeof cart === 'object' ? cart : {};
    var items = Array.isArray(cartObject.items) ? cartObject.items : [];
    if (!items.length) return;

    var rows = document.querySelectorAll('[data-cartitem]');
    Array.prototype.forEach.call(rows, function (row, index) {
      var item = items[index];
      if (!item || !item.key) return;

      row.setAttribute('data-cartitem-key', String(item.key));

      var input = row.querySelector('input[data-quantity-input]');
      if (!input) return;

      var nextId = 'updates_' + String(item.key);
      input.id = nextId;

      var label = row.querySelector('label.quantity-selector__label');
      if (label) {
        label.setAttribute('for', nextId);
      }
    });
  }

  async function applyCheckoutLinePropertyPatches(cart, patches) {
    var cartObject = cart && typeof cart === 'object' ? cart : {};
    var cartItems = Array.isArray(cartObject.items) ? cartObject.items : [];
    var patchSet = patches && typeof patches === 'object' ? patches : {};
    var patchIndexes = Object.keys(patchSet);
    var didApply = false;
    var latestCart = null;

    for (var patchIndex = 0; patchIndex < patchIndexes.length; patchIndex += 1) {
      var indexKey = patchIndexes[patchIndex];
      var lineIndex = toInteger(indexKey, -1);
      if (lineIndex < 0 || lineIndex >= cartItems.length) continue;

      var cartItem = cartItems[lineIndex] || {};

      var patchProperties = patchSet[indexKey];
      if (!patchProperties || typeof patchProperties !== 'object') continue;
      if (!hasPropertyPatchChanges(cartItem.properties, patchProperties)) continue;

      var mergedProperties = {};
      if (cartItem.properties && typeof cartItem.properties === 'object') {
        Object.keys(cartItem.properties).forEach(function (propertyKey) {
          var value = cartItem.properties[propertyKey];
          if (value === null || typeof value === 'undefined') return;
          mergedProperties[propertyKey] = String(value);
        });
      }
      Object.keys(patchProperties).forEach(function (propertyKey) {
        var value = patchProperties[propertyKey];
        if (value === null || typeof value === 'undefined') return;
        mergedProperties[propertyKey] = String(value);
      });

      var response = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: lineIndex + 1,
          quantity: Math.max(1, toInteger(cartItem.quantity, 1)),
          properties: mergedProperties
        })
      });

      if (!response.ok) {
        throw new Error('Unable to apply checkout line metadata.');
      }

      var updatedCart = await response.json();
      if (updatedCart && typeof updatedCart === 'object') {
        latestCart = updatedCart;
      }
      didApply = true;
    }

    return {
      didApply: didApply,
      cart: latestCart
    };
  }

  async function syncCartLoyaltyMetadata(cartForm) {
    var cart = await getCartPayload();
    var lines = buildLoyaltyApplyLinesFromCart(cart);

    if (!lines.length) {
      state.cartLoyaltySummary = null;
      renderCartLoyaltySummary(null);
      return;
    }

    var summary = await evaluateLoyaltyCartApply(lines);
    state.cartLoyaltySummary = summary;
    renderCartLoyaltySummary(summary);

    if (!summary) return;

    var checkoutPayload = summary.checkoutPayload || {};
    var noteAttributes = normalizeNoteAttributes(
      checkoutPayload.note_attributes || checkoutPayload.noteAttributes || null
    );
    var linePropertyPatches = normalizeLinePropertyPatches(
      checkoutPayload.line_item_properties_by_index || checkoutPayload.lineItemPropertiesByIndex || null
    );

    setCartAttributeInputs(cartForm, noteAttributes);
    var attributeUpdates = buildCartAttributeUpdates(cart, noteAttributes);
    var attributesUpdated = await applyCartAttributeUpdates(attributeUpdates);
    var linesUpdated = false;
    var patchedCart = null;
    if (Object.keys(linePropertyPatches).length) {
      var patchResult = await applyCheckoutLinePropertyPatches(cart, linePropertyPatches);
      linesUpdated = Boolean(patchResult && patchResult.didApply);
      patchedCart = patchResult && patchResult.cart ? patchResult.cart : null;
    }

    if (patchedCart) {
      syncCartLineKeysInDom(patchedCart);
    }

    if (attributesUpdated || linesUpdated) {
      await updateHeaderCartCount();
    }
  }

  function initCartLoyalty() {
    var cartSection = getStaticCartRoot();
    if (!cartSection) return;
    if (!isCustomerLoggedIn || !state.loyaltyEvaluateEnabled) return;
    removeLegacyCartLoyaltyRows();

    var cartForm = cartSection.querySelector('form[action="' + (window.Theme && window.Theme.routes ? window.Theme.routes.cart_url : '/cart') + '"], form[aria-label="cart checkout"]');
    if (!cartForm && cartSection.matches && cartSection.matches('form[aria-label="cart checkout"]')) {
      cartForm = cartSection;
    }
    if (!cartForm) return;

    var cartSyncInFlight = false;
    var cartSyncQueued = false;
    var cartSyncTimer = null;

    var runCartSync = function () {
      if (cartSyncInFlight) {
        cartSyncQueued = true;
        return;
      }

      cartSyncInFlight = true;
      cartSyncQueued = false;

      (async function () {
        try {
          await syncCartLoyaltyMetadata(cartForm);
        } catch (error) {
          // Keep cart usable even when loyalty sync fails.
        } finally {
          cartSyncInFlight = false;
          if (cartSyncQueued) {
            window.setTimeout(runCartSync, 120);
          }
        }
      })();
    };

    var scheduleCartSync = function (delay) {
      if (cartSyncTimer) window.clearTimeout(cartSyncTimer);
      cartSyncTimer = window.setTimeout(runCartSync, Math.max(0, toInteger(delay, 250)));
    };

    scheduleCartSync(120);
    window.addEventListener('cartcount:update', function () {
      scheduleCartSync(350);
    });

    var cartListContainer = document.querySelector('[data-html="list"]');
    if (cartListContainer && typeof MutationObserver !== 'undefined') {
      var cartListObserver = new MutationObserver(function () {
        scheduleCartSync(500);
      });
      cartListObserver.observe(cartListContainer, {
        childList: true,
        subtree: true
      });
    }

    cartForm.addEventListener('submit', function (event) {
      var submitter = event.submitter || null;
      if (!submitter && document.activeElement && document.activeElement.form === cartForm) {
        submitter = document.activeElement;
      }
      if (!submitter || submitter.name !== 'checkout') return;
      if (cartForm.getAttribute('data-loyalty-checkout-processing') === 'true') return;

      event.preventDefault();
      cartForm.setAttribute('data-loyalty-checkout-processing', 'true');
      var previousDisabled = submitter.disabled;
      submitter.disabled = true;

      (async function () {
        try {
          var cart = await getCartPayload();
          var lines = buildLoyaltyApplyLinesFromCart(cart);
          if (lines.length) {
            var applySummary = await evaluateLoyaltyCheckoutApply(lines);
            if (applySummary) {
              var checkoutPayload = applySummary.checkoutPayload || {};
              var noteAttributes = normalizeNoteAttributes(checkoutPayload.note_attributes || checkoutPayload.noteAttributes || null);
              var linePropertyPatches = normalizeLinePropertyPatches(
                checkoutPayload.line_item_properties_by_index || checkoutPayload.lineItemPropertiesByIndex || null
              );
              var attributeUpdates = buildCartAttributeUpdates(cart, noteAttributes);

              setCartAttributeInputs(cartForm, noteAttributes);
              await applyCartAttributeUpdates(attributeUpdates);
              if (Object.keys(linePropertyPatches).length) {
                await applyCheckoutLinePropertyPatches(cart, linePropertyPatches);
              }
            }
          }

          cartForm.submit();
        } catch (error) {
          showToast(error.message || 'Unable to prepare loyalty checkout. Please try again.', 'error');
        } finally {
          cartForm.setAttribute('data-loyalty-checkout-processing', 'false');
          submitter.disabled = previousDisabled;
        }
      })();
    });
  }

  document.addEventListener('click', function (event) {
    var heartButton = event.target.closest('[data-saved-lists-heart]');
    if (!heartButton) return;

    event.preventDefault();
    event.stopPropagation();
    openHeartModal(heartButton);
  });

  initSavedListsPage();
  initOrdersPage();
  initCartLoyalty();
  bindProductCalloutEvents();
  updateProductAvailabilityAndShippingMessaging();
  refreshLoyaltyContextCallouts();
})();
